export const arr=[
    {
        "id": "bitcoin",
        "symbol": "btc",
        "name": "Bitcoin",
        "image": "https://assets.coingecko.com/coins/images/1/large/bitcoin.png?1547033579",
        "current_price": 27303,
        "market_cap": 531488100433,
        "market_cap_rank": 1,
        "fully_diluted_valuation": 572682928823,
        "total_volume": 11771518445,
        "high_24h": 27405,
        "low_24h": 26417,
        "price_change_24h": 744.14,
        "price_change_percentage_24h": 2.80183,
        "market_cap_change_24h": 13474185073,
        "market_cap_change_percentage_24h": 2.60112,
        "circulating_supply": 19489406,
        "total_supply": 21000000,
        "max_supply": 21000000,
        "ath": 69045,
        "ath_change_percentage": -60.45785,
        "ath_date": "2021-11-10T14:24:11.849Z",
        "atl": 67.81,
        "atl_change_percentage": 40162.77284,
        "atl_date": "2013-07-06T00:00:00.000Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:40.680Z"
    },
    {
        "id": "ethereum",
        "symbol": "eth",
        "name": "Ethereum",
        "image": "https://assets.coingecko.com/coins/images/279/large/ethereum.png?1595348880",
        "current_price": 1659.1,
        "market_cap": 199182039412,
        "market_cap_rank": 2,
        "fully_diluted_valuation": 199182039412,
        "total_volume": 9270462229,
        "high_24h": 1667.95,
        "low_24h": 1610.47,
        "price_change_24h": 28.26,
        "price_change_percentage_24h": 1.73298,
        "market_cap_change_24h": 3029733530,
        "market_cap_change_percentage_24h": 1.54458,
        "circulating_supply": 120225429.200067,
        "total_supply": 120225429.200067,
        "max_supply": null,
        "ath": 4878.26,
        "ath_change_percentage": -66.00556,
        "ath_date": "2021-11-10T14:24:19.604Z",
        "atl": 0.432979,
        "atl_change_percentage": 382906.584,
        "atl_date": "2015-10-20T00:00:00.000Z",
        "roi": {
            "times": 80.23412368032778,
            "currency": "btc",
            "percentage": 8023.412368032778
        },
        "last_updated": "2023-09-18T15:21:39.229Z"
    },
    {
        "id": "tether",
        "symbol": "usdt",
        "name": "Tether",
        "image": "https://assets.coingecko.com/coins/images/325/large/Tether.png?1668148663",
        "current_price": 1,
        "market_cap": 83017591113,
        "market_cap_rank": 3,
        "fully_diluted_valuation": 83017591113,
        "total_volume": 13892909820,
        "high_24h": 1.002,
        "low_24h": 0.998601,
        "price_change_24h": -0.000164708667951263,
        "price_change_percentage_24h": -0.01647,
        "market_cap_change_24h": -44196260.983444214,
        "market_cap_change_percentage_24h": -0.05321,
        "circulating_supply": 83041923535.6218,
        "total_supply": 83041923535.6218,
        "max_supply": null,
        "ath": 1.32,
        "ath_change_percentage": -24.40692,
        "ath_date": "2018-07-24T00:00:00.000Z",
        "atl": 0.572521,
        "atl_change_percentage": 74.69551,
        "atl_date": "2015-03-02T00:00:00.000Z",
        "roi": null,
        "last_updated": "2023-09-18T15:20:00.509Z"
    },
    {
        "id": "binancecoin",
        "symbol": "bnb",
        "name": "BNB",
        "image": "https://assets.coingecko.com/coins/images/825/large/bnb-icon2_2x.png?1644979850",
        "current_price": 219.68,
        "market_cap": 33771276643,
        "market_cap_rank": 4,
        "fully_diluted_valuation": 43899807245,
        "total_volume": 608754804,
        "high_24h": 220.7,
        "low_24h": 215.32,
        "price_change_24h": 3.43,
        "price_change_percentage_24h": 1.58505,
        "market_cap_change_24h": 465283580,
        "market_cap_change_percentage_24h": 1.397,
        "circulating_supply": 153856150,
        "total_supply": 153856150,
        "max_supply": 200000000,
        "ath": 686.31,
        "ath_change_percentage": -67.99101,
        "ath_date": "2021-05-10T07:24:17.097Z",
        "atl": 0.0398177,
        "atl_change_percentage": 551613.92903,
        "atl_date": "2017-10-19T00:00:00.000Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:44.636Z"
    },
    {
        "id": "ripple",
        "symbol": "xrp",
        "name": "XRP",
        "image": "https://assets.coingecko.com/coins/images/44/large/xrp-symbol-white-128.png?1605778731",
        "current_price": 0.505234,
        "market_cap": 26900444708,
        "market_cap_rank": 5,
        "fully_diluted_valuation": 50588137265,
        "total_volume": 708310385,
        "high_24h": 0.506119,
        "low_24h": 0.489211,
        "price_change_24h": 0.00596089,
        "price_change_percentage_24h": 1.19391,
        "market_cap_change_24h": 316641428,
        "market_cap_change_percentage_24h": 1.19111,
        "circulating_supply": 53175400720,
        "total_supply": 99988428101,
        "max_supply": 100000000000,
        "ath": 3.4,
        "ath_change_percentage": -85.13234,
        "ath_date": "2018-01-07T00:00:00.000Z",
        "atl": 0.00268621,
        "atl_change_percentage": 18709.79737,
        "atl_date": "2014-05-22T00:00:00.000Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:39.526Z"
    },
    {
        "id": "usd-coin",
        "symbol": "usdc",
        "name": "USD Coin",
        "image": "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png?1547042389",
        "current_price": 0.999818,
        "market_cap": 26053763048,
        "market_cap_rank": 6,
        "fully_diluted_valuation": 26060682085,
        "total_volume": 4693821063,
        "high_24h": 1.003,
        "low_24h": 0.99786,
        "price_change_24h": -0.000322930724384274,
        "price_change_percentage_24h": -0.03229,
        "market_cap_change_24h": -108150561.56135559,
        "market_cap_change_percentage_24h": -0.41339,
        "circulating_supply": 26066682357.3394,
        "total_supply": 26073604825.7662,
        "max_supply": null,
        "ath": 1.17,
        "ath_change_percentage": -14.75111,
        "ath_date": "2019-05-08T00:40:28.300Z",
        "atl": 0.877647,
        "atl_change_percentage": 13.90905,
        "atl_date": "2023-03-11T08:02:13.981Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:38.554Z"
    },
    {
        "id": "staked-ether",
        "symbol": "steth",
        "name": "Lido Staked Ether",
        "image": "https://assets.coingecko.com/coins/images/13442/large/steth_logo.png?1608607546",
        "current_price": 1659.66,
        "market_cap": 14380994881,
        "market_cap_rank": 7,
        "fully_diluted_valuation": 14380994881,
        "total_volume": 4431681,
        "high_24h": 1667.75,
        "low_24h": 1611.44,
        "price_change_24h": 30.48,
        "price_change_percentage_24h": 1.87114,
        "market_cap_change_24h": 288881075,
        "market_cap_change_percentage_24h": 2.04995,
        "circulating_supply": 8668647.49019287,
        "total_supply": 8668647.49019287,
        "max_supply": 8668647.49019287,
        "ath": 4829.57,
        "ath_change_percentage": -65.67338,
        "ath_date": "2021-11-10T14:40:47.256Z",
        "atl": 482.9,
        "atl_change_percentage": 243.30943,
        "atl_date": "2020-12-22T04:08:21.854Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:48.041Z"
    },
    {
        "id": "cardano",
        "symbol": "ada",
        "name": "Cardano",
        "image": "https://assets.coingecko.com/coins/images/975/large/cardano.png?1547034860",
        "current_price": 0.254586,
        "market_cap": 8920445907,
        "market_cap_rank": 8,
        "fully_diluted_valuation": 11454410821,
        "total_volume": 118597626,
        "high_24h": 0.25517,
        "low_24h": 0.244853,
        "price_change_24h": 0.004272,
        "price_change_percentage_24h": 1.70665,
        "market_cap_change_24h": 138071897,
        "market_cap_change_percentage_24h": 1.57215,
        "circulating_supply": 35045020830.3234,
        "total_supply": 45000000000,
        "max_supply": 45000000000,
        "ath": 3.09,
        "ath_change_percentage": -91.75426,
        "ath_date": "2021-09-02T06:00:10.474Z",
        "atl": 0.01925275,
        "atl_change_percentage": 1222.09035,
        "atl_date": "2020-03-13T02:22:55.044Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:47.715Z"
    },
    {
        "id": "dogecoin",
        "symbol": "doge",
        "name": "Dogecoin",
        "image": "https://assets.coingecko.com/coins/images/5/large/dogecoin.png?1547792256",
        "current_price": 0.06258,
        "market_cap": 8820659244,
        "market_cap_rank": 9,
        "fully_diluted_valuation": 8820644862,
        "total_volume": 273212416,
        "high_24h": 0.062816,
        "low_24h": 0.061099,
        "price_change_24h": 0.00046409,
        "price_change_percentage_24h": 0.74713,
        "market_cap_change_24h": 54076227,
        "market_cap_change_percentage_24h": 0.61684,
        "circulating_supply": 141058956383.705,
        "total_supply": 141058726383.705,
        "max_supply": null,
        "ath": 0.731578,
        "ath_change_percentage": -91.44799,
        "ath_date": "2021-05-08T05:08:23.458Z",
        "atl": 0.0000869,
        "atl_change_percentage": 71893.01614,
        "atl_date": "2015-05-06T00:00:00.000Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:36.681Z"
    },
    {
        "id": "the-open-network",
        "symbol": "ton",
        "name": "Toncoin",
        "image": "https://assets.coingecko.com/coins/images/17980/large/ton_symbol.png?1670498136",
        "current_price": 2.51,
        "market_cap": 8610263456,
        "market_cap_rank": 10,
        "fully_diluted_valuation": 12736817642,
        "total_volume": 47848625,
        "high_24h": 2.52,
        "low_24h": 2.26,
        "price_change_24h": 0.17189,
        "price_change_percentage_24h": 7.34206,
        "market_cap_change_24h": 458143028,
        "market_cap_change_percentage_24h": 5.61992,
        "circulating_supply": 3443745564.0336,
        "total_supply": 5094194791.58889,
        "max_supply": null,
        "ath": 5.29,
        "ath_change_percentage": -52.82795,
        "ath_date": "2021-11-12T06:50:02.476Z",
        "atl": 0.519364,
        "atl_change_percentage": 380.54502,
        "atl_date": "2021-09-21T00:33:11.092Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:40.965Z"
    },
    {
        "id": "solana",
        "symbol": "sol",
        "name": "Solana",
        "image": "https://assets.coingecko.com/coins/images/4128/large/solana.png?1640133422",
        "current_price": 19.95,
        "market_cap": 8210176178,
        "market_cap_rank": 11,
        "fully_diluted_valuation": 11131068549,
        "total_volume": 300431262,
        "high_24h": 19.95,
        "low_24h": 18.64,
        "price_change_24h": 0.95081,
        "price_change_percentage_24h": 5.00492,
        "market_cap_change_24h": 395532252,
        "market_cap_change_percentage_24h": 5.06142,
        "circulating_supply": 411396480.433058,
        "total_supply": 557756901.364895,
        "max_supply": null,
        "ath": 259.96,
        "ath_change_percentage": -92.33748,
        "ath_date": "2021-11-06T21:54:35.825Z",
        "atl": 0.500801,
        "atl_change_percentage": 3877.51214,
        "atl_date": "2020-05-11T19:35:23.449Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:39.306Z"
    },
    {
        "id": "tron",
        "symbol": "trx",
        "name": "TRON",
        "image": "https://assets.coingecko.com/coins/images/1094/large/tron-logo.png?1547035066",
        "current_price": 0.084717,
        "market_cap": 7546693511,
        "market_cap_rank": 12,
        "fully_diluted_valuation": 7546723792,
        "total_volume": 223137185,
        "high_24h": 0.084829,
        "low_24h": 0.083119,
        "price_change_24h": 0.00113136,
        "price_change_percentage_24h": 1.35353,
        "market_cap_change_24h": 87940188,
        "market_cap_change_percentage_24h": 1.17902,
        "circulating_supply": 89176367016.3318,
        "total_supply": 89176724837.6342,
        "max_supply": null,
        "ath": 0.231673,
        "ath_change_percentage": -63.43781,
        "ath_date": "2018-01-05T00:00:00.000Z",
        "atl": 0.00180434,
        "atl_change_percentage": 4594.48921,
        "atl_date": "2017-11-12T00:00:00.000Z",
        "roi": {
            "times": 43.58800263154591,
            "currency": "usd",
            "percentage": 4358.800263154591
        },
        "last_updated": "2023-09-18T15:21:43.848Z"
    },
    {
        "id": "polkadot",
        "symbol": "dot",
        "name": "Polkadot",
        "image": "https://assets.coingecko.com/coins/images/12171/large/polkadot.png?1639712644",
        "current_price": 4.2,
        "market_cap": 5360610587,
        "market_cap_rank": 13,
        "fully_diluted_valuation": 5700717734,
        "total_volume": 106688342,
        "high_24h": 4.22,
        "low_24h": 4.03,
        "price_change_24h": 0.070339,
        "price_change_percentage_24h": 1.7035,
        "market_cap_change_24h": 90171378,
        "market_cap_change_percentage_24h": 1.71089,
        "circulating_supply": 1275882563.39997,
        "total_supply": 1356831696.34953,
        "max_supply": null,
        "ath": 54.98,
        "ath_change_percentage": -92.36312,
        "ath_date": "2021-11-04T14:10:09.301Z",
        "atl": 2.7,
        "atl_change_percentage": 55.65878,
        "atl_date": "2020-08-20T05:48:11.359Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:44.394Z"
    },
    {
        "id": "matic-network",
        "symbol": "matic",
        "name": "Polygon",
        "image": "https://assets.coingecko.com/coins/images/4713/large/matic-token-icon.png?1624446912",
        "current_price": 0.532432,
        "market_cap": 4972926204,
        "market_cap_rank": 14,
        "fully_diluted_valuation": 5336061708,
        "total_volume": 173712733,
        "high_24h": 0.534839,
        "low_24h": 0.513205,
        "price_change_24h": 0.00882687,
        "price_change_percentage_24h": 1.68579,
        "market_cap_change_24h": 91521956,
        "market_cap_change_percentage_24h": 1.87491,
        "circulating_supply": 9319469069.28493,
        "total_supply": 10000000000,
        "max_supply": 10000000000,
        "ath": 2.92,
        "ath_change_percentage": -81.7418,
        "ath_date": "2021-12-27T02:08:34.307Z",
        "atl": 0.00314376,
        "atl_change_percentage": 16836.94959,
        "atl_date": "2019-05-10T00:00:00.000Z",
        "roi": {
            "times": 201.44570848422737,
            "currency": "usd",
            "percentage": 20144.570848422736
        },
        "last_updated": "2023-09-18T15:21:46.877Z"
    },
    {
        "id": "litecoin",
        "symbol": "ltc",
        "name": "Litecoin",
        "image": "https://assets.coingecko.com/coins/images/2/large/litecoin.png?1547033580",
        "current_price": 67.19,
        "market_cap": 4953744936,
        "market_cap_rank": 15,
        "fully_diluted_valuation": 5648583631,
        "total_volume": 594190764,
        "high_24h": 67.34,
        "low_24h": 63.1,
        "price_change_24h": 2.9,
        "price_change_percentage_24h": 4.51192,
        "market_cap_change_24h": 212841387,
        "market_cap_change_percentage_24h": 4.48947,
        "circulating_supply": 73667064.4834713,
        "total_supply": 84000000,
        "max_supply": 84000000,
        "ath": 410.26,
        "ath_change_percentage": -83.62577,
        "ath_date": "2021-05-10T03:13:07.904Z",
        "atl": 1.15,
        "atl_change_percentage": 5747.35468,
        "atl_date": "2015-01-14T00:00:00.000Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:47.737Z"
    },
    {
        "id": "wrapped-bitcoin",
        "symbol": "wbtc",
        "name": "Wrapped Bitcoin",
        "image": "https://assets.coingecko.com/coins/images/7598/large/wrapped_bitcoin_wbtc.png?1548822744",
        "current_price": 27302,
        "market_cap": 4445360119,
        "market_cap_rank": 16,
        "fully_diluted_valuation": 4445360119,
        "total_volume": 60761449,
        "high_24h": 27413,
        "low_24h": 26402,
        "price_change_24h": 730.71,
        "price_change_percentage_24h": 2.74995,
        "market_cap_change_24h": 113103818,
        "market_cap_change_percentage_24h": 2.61074,
        "circulating_supply": 162874.87174305,
        "total_supply": 162874.87174305,
        "max_supply": 162874.87174305,
        "ath": 70643,
        "ath_change_percentage": -61.38809,
        "ath_date": "2021-11-10T14:40:19.650Z",
        "atl": 3139.17,
        "atl_change_percentage": 768.91563,
        "atl_date": "2019-04-02T00:00:00.000Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:42.726Z"
    },
    {
        "id": "shiba-inu",
        "symbol": "shib",
        "name": "Shiba Inu",
        "image": "https://assets.coingecko.com/coins/images/11939/large/shiba.png?1622619446",
        "current_price": 0.00000736,
        "market_cap": 4333163253,
        "market_cap_rank": 17,
        "fully_diluted_valuation": 7352569252,
        "total_volume": 88570194,
        "high_24h": 0.00000741,
        "low_24h": 0.00000712,
        "price_change_24h": 6.9355e-8,
        "price_change_percentage_24h": 0.95173,
        "market_cap_change_24h": 39392139,
        "market_cap_change_percentage_24h": 0.91743,
        "circulating_supply": 589330209628835,
        "total_supply": 999983366760752,
        "max_supply": null,
        "ath": 0.00008616,
        "ath_change_percentage": -91.46709,
        "ath_date": "2021-10-28T03:54:55.568Z",
        "atl": 5.6366e-11,
        "atl_change_percentage": 13042867.92162,
        "atl_date": "2020-11-28T11:26:25.838Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:45.495Z"
    },
    {
        "id": "bitcoin-cash",
        "symbol": "bch",
        "name": "Bitcoin Cash",
        "image": "https://assets.coingecko.com/coins/images/780/large/bitcoin-cash-circle.png?1594689492",
        "current_price": 221.37,
        "market_cap": 4320882303,
        "market_cap_rank": 18,
        "fully_diluted_valuation": 4651421174,
        "total_volume": 236118908,
        "high_24h": 224.4,
        "low_24h": 205.98,
        "price_change_24h": 7.75,
        "price_change_percentage_24h": 3.62711,
        "market_cap_change_24h": 154657762,
        "market_cap_change_percentage_24h": 3.71218,
        "circulating_supply": 19507699.8966508,
        "total_supply": 21000000,
        "max_supply": 21000000,
        "ath": 3785.82,
        "ath_change_percentage": -94.15167,
        "ath_date": "2017-12-20T00:00:00.000Z",
        "atl": 76.93,
        "atl_change_percentage": 187.78547,
        "atl_date": "2018-12-16T00:00:00.000Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:41.965Z"
    },
    {
        "id": "dai",
        "symbol": "dai",
        "name": "Dai",
        "image": "https://assets.coingecko.com/coins/images/9956/large/Badge_Dai.png?1687143508",
        "current_price": 1,
        "market_cap": 3872673549,
        "market_cap_rank": 19,
        "fully_diluted_valuation": 3872673549,
        "total_volume": 78517375,
        "high_24h": 1.002,
        "low_24h": 0.998117,
        "price_change_24h": 0.0005134,
        "price_change_percentage_24h": 0.05135,
        "market_cap_change_24h": 13262900,
        "market_cap_change_percentage_24h": 0.34365,
        "circulating_supply": 3874127675.26343,
        "total_supply": 3874127675.26343,
        "max_supply": null,
        "ath": 1.22,
        "ath_change_percentage": -17.90633,
        "ath_date": "2020-03-13T03:02:50.373Z",
        "atl": 0.88196,
        "atl_change_percentage": 13.45922,
        "atl_date": "2023-03-11T07:50:50.514Z",
        "roi": null,
        "last_updated": "2023-09-18T15:20:00.475Z"
    },
    {
        "id": "chainlink",
        "symbol": "link",
        "name": "Chainlink",
        "image": "https://assets.coingecko.com/coins/images/877/large/chainlink-new-logo.png?1547034700",
        "current_price": 6.78,
        "market_cap": 3654026926,
        "market_cap_rank": 20,
        "fully_diluted_valuation": 6790609778,
        "total_volume": 411116554,
        "high_24h": 6.81,
        "low_24h": 6.07,
        "price_change_24h": 0.590389,
        "price_change_percentage_24h": 9.54349,
        "market_cap_change_24h": 320319842,
        "market_cap_change_percentage_24h": 9.60852,
        "circulating_supply": 538099971.2305644,
        "total_supply": 1000000000,
        "max_supply": 1000000000,
        "ath": 52.7,
        "ath_change_percentage": -87.1372,
        "ath_date": "2021-05-10T00:13:57.214Z",
        "atl": 0.148183,
        "atl_change_percentage": 4474.24198,
        "atl_date": "2017-11-29T00:00:00.000Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:43.579Z"
    },
    {
        "id": "leo-token",
        "symbol": "leo",
        "name": "LEO Token",
        "image": "https://assets.coingecko.com/coins/images/8418/large/leo-token.png?1558326215",
        "current_price": 3.67,
        "market_cap": 3412374597,
        "market_cap_rank": 21,
        "fully_diluted_valuation": 3617883368,
        "total_volume": 393301,
        "high_24h": 3.7,
        "low_24h": 3.58,
        "price_change_24h": -0.023262198171539072,
        "price_change_percentage_24h": -0.62943,
        "market_cap_change_24h": -19791755.159956455,
        "market_cap_change_percentage_24h": -0.57665,
        "circulating_supply": 929274360.9,
        "total_supply": 985239504,
        "max_supply": null,
        "ath": 8.14,
        "ath_change_percentage": -54.87645,
        "ath_date": "2022-02-08T17:40:10.285Z",
        "atl": 0.799859,
        "atl_change_percentage": 358.95029,
        "atl_date": "2019-12-24T15:14:35.376Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:42.746Z"
    },
    {
        "id": "uniswap",
        "symbol": "uni",
        "name": "Uniswap",
        "image": "https://assets.coingecko.com/coins/images/12504/large/uni.jpg?1687143398",
        "current_price": 4.45,
        "market_cap": 3351858449,
        "market_cap_rank": 22,
        "fully_diluted_valuation": 4446811720,
        "total_volume": 122614405,
        "high_24h": 4.45,
        "low_24h": 4.24,
        "price_change_24h": 0.107531,
        "price_change_percentage_24h": 2.47647,
        "market_cap_change_24h": 76937370,
        "market_cap_change_percentage_24h": 2.34929,
        "circulating_supply": 753766667,
        "total_supply": 1000000000,
        "max_supply": 1000000000,
        "ath": 44.92,
        "ath_change_percentage": -90.10973,
        "ath_date": "2021-05-03T05:25:04.822Z",
        "atl": 1.03,
        "atl_change_percentage": 331.24088,
        "atl_date": "2020-09-17T01:20:38.214Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:40.184Z"
    },
    {
        "id": "stellar",
        "symbol": "xlm",
        "name": "Stellar",
        "image": "https://assets.coingecko.com/coins/images/100/large/Stellar_symbol_black_RGB.png?1552356157",
        "current_price": 0.11914,
        "market_cap": 3282917991,
        "market_cap_rank": 23,
        "fully_diluted_valuation": 5961118362,
        "total_volume": 53343315,
        "high_24h": 0.119263,
        "low_24h": 0.115466,
        "price_change_24h": 0.00161212,
        "price_change_percentage_24h": 1.37169,
        "market_cap_change_24h": 44380057,
        "market_cap_change_percentage_24h": 1.37037,
        "circulating_supply": 27537075550,
        "total_supply": 50001787183.4675,
        "max_supply": 50001787183.4675,
        "ath": 0.875563,
        "ath_change_percentage": -86.39095,
        "ath_date": "2018-01-03T00:00:00.000Z",
        "atl": 0.00047612,
        "atl_change_percentage": 24926.23891,
        "atl_date": "2015-03-05T00:00:00.000Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:43.467Z"
    },
    {
        "id": "avalanche-2",
        "symbol": "avax",
        "name": "Avalanche",
        "image": "https://assets.coingecko.com/coins/images/12559/large/Avalanche_Circle_RedWhite_Trans.png?1670992574",
        "current_price": 9.28,
        "market_cap": 3281780611,
        "market_cap_rank": 24,
        "fully_diluted_valuation": 6675323354,
        "total_volume": 143849133,
        "high_24h": 9.31,
        "low_24h": 8.87,
        "price_change_24h": 0.060126,
        "price_change_percentage_24h": 0.65226,
        "market_cap_change_24h": 18397863,
        "market_cap_change_percentage_24h": 0.56377,
        "circulating_supply": 353972671.409161,
        "total_supply": 431348863.599889,
        "max_supply": 720000000,
        "ath": 144.96,
        "ath_change_percentage": -93.60782,
        "ath_date": "2021-11-21T14:18:56.538Z",
        "atl": 2.8,
        "atl_change_percentage": 230.80917,
        "atl_date": "2020-12-31T13:15:21.540Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:41.779Z"
    },
    {
        "id": "true-usd",
        "symbol": "tusd",
        "name": "TrueUSD",
        "image": "https://assets.coingecko.com/coins/images/3449/large/tusd.png?1618395665",
        "current_price": 1,
        "market_cap": 3104399383,
        "market_cap_rank": 25,
        "fully_diluted_valuation": 3104399383,
        "total_volume": 320575842,
        "high_24h": 1.003,
        "low_24h": 0.996052,
        "price_change_24h": 0.00151859,
        "price_change_percentage_24h": 0.15204,
        "market_cap_change_24h": 2010106,
        "market_cap_change_percentage_24h": 0.06479,
        "circulating_supply": 3104176323.69,
        "total_supply": 3104176323.69,
        "max_supply": null,
        "ath": 1.62,
        "ath_change_percentage": -38.19515,
        "ath_date": "2018-08-26T20:41:09.375Z",
        "atl": 0.88355,
        "atl_change_percentage": 13.21596,
        "atl_date": "2020-03-12T10:47:51.380Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:33.482Z"
    },
    {
        "id": "monero",
        "symbol": "xmr",
        "name": "Monero",
        "image": "https://assets.coingecko.com/coins/images/69/large/monero_logo.png?1547033729",
        "current_price": 146.83,
        "market_cap": 2666849669,
        "market_cap_rank": 26,
        "fully_diluted_valuation": null,
        "total_volume": 47627230,
        "high_24h": 148,
        "low_24h": 144.25,
        "price_change_24h": 2.41,
        "price_change_percentage_24h": 1.66672,
        "market_cap_change_24h": 45927890,
        "market_cap_change_percentage_24h": 1.75236,
        "circulating_supply": 18147820.3764146,
        "total_supply": null,
        "max_supply": null,
        "ath": 542.33,
        "ath_change_percentage": -72.92299,
        "ath_date": "2018-01-09T00:00:00.000Z",
        "atl": 0.216177,
        "atl_change_percentage": 67828.49141,
        "atl_date": "2015-01-14T00:00:00.000Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:46.961Z"
    },
    {
        "id": "okb",
        "symbol": "okb",
        "name": "OKB",
        "image": "https://assets.coingecko.com/coins/images/4463/large/WeChat_Image_20220118095654.png?1642471050",
        "current_price": 43.81,
        "market_cap": 2626261019,
        "market_cap_rank": 27,
        "fully_diluted_valuation": 13131305095,
        "total_volume": 11694700,
        "high_24h": 43.91,
        "low_24h": 42.86,
        "price_change_24h": 0.583817,
        "price_change_percentage_24h": 1.35063,
        "market_cap_change_24h": 30604644,
        "market_cap_change_percentage_24h": 1.17907,
        "circulating_supply": 60000000,
        "total_supply": 235957685.3,
        "max_supply": 300000000,
        "ath": 58.66,
        "ath_change_percentage": -25.31485,
        "ath_date": "2023-02-18T01:21:37.582Z",
        "atl": 0.580608,
        "atl_change_percentage": 7445.41567,
        "atl_date": "2019-01-14T00:00:00.000Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:42.424Z"
    },
    {
        "id": "binance-usd",
        "symbol": "busd",
        "name": "Binance USD",
        "image": "https://assets.coingecko.com/coins/images/9576/large/BUSD.png?1568947766",
        "current_price": 1,
        "market_cap": 2471445202,
        "market_cap_rank": 28,
        "fully_diluted_valuation": 2471445202,
        "total_volume": 2875396969,
        "high_24h": 1.003,
        "low_24h": 0.998166,
        "price_change_24h": 0.00030142,
        "price_change_percentage_24h": 0.03014,
        "market_cap_change_24h": -22789826.209148407,
        "market_cap_change_percentage_24h": -0.9137,
        "circulating_supply": 2471587331.3,
        "total_supply": 2471587331.3,
        "max_supply": null,
        "ath": 1.15,
        "ath_change_percentage": -13.33506,
        "ath_date": "2020-03-13T02:35:42.953Z",
        "atl": 0.901127,
        "atl_change_percentage": 11.00433,
        "atl_date": "2021-05-19T13:04:37.445Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:44.307Z"
    },
    {
        "id": "ethereum-classic",
        "symbol": "etc",
        "name": "Ethereum Classic",
        "image": "https://assets.coingecko.com/coins/images/453/large/ethereum-classic-logo.png?1547034169",
        "current_price": 15.98,
        "market_cap": 2285831744,
        "market_cap_rank": 29,
        "fully_diluted_valuation": 3366266342,
        "total_volume": 70943741,
        "high_24h": 16.01,
        "low_24h": 15.23,
        "price_change_24h": 0.470294,
        "price_change_percentage_24h": 3.03286,
        "market_cap_change_24h": 70140016,
        "market_cap_change_percentage_24h": 3.1656,
        "circulating_supply": 143073868.694117,
        "total_supply": 210700000,
        "max_supply": 210700000,
        "ath": 167.09,
        "ath_change_percentage": -90.4377,
        "ath_date": "2021-05-06T18:34:22.133Z",
        "atl": 0.615038,
        "atl_change_percentage": 2497.75786,
        "atl_date": "2016-07-25T00:00:00.000Z",
        "roi": {
            "times": 34.50424084440111,
            "currency": "usd",
            "percentage": 3450.424084440111
        },
        "last_updated": "2023-09-18T15:21:48.050Z"
    },
    {
        "id": "cosmos",
        "symbol": "atom",
        "name": "Cosmos Hub",
        "image": "https://assets.coingecko.com/coins/images/1481/large/cosmos_hub.png?1555657960",
        "current_price": 7.42,
        "market_cap": 2171177166,
        "market_cap_rank": 30,
        "fully_diluted_valuation": null,
        "total_volume": 100416063,
        "high_24h": 7.46,
        "low_24h": 6.86,
        "price_change_24h": 0.295755,
        "price_change_percentage_24h": 4.15029,
        "market_cap_change_24h": 86696832,
        "market_cap_change_percentage_24h": 4.15916,
        "circulating_supply": 292586163.827428,
        "total_supply": null,
        "max_supply": null,
        "ath": 44.45,
        "ath_change_percentage": -83.30661,
        "ath_date": "2022-01-17T00:34:41.497Z",
        "atl": 1.16,
        "atl_change_percentage": 539.61268,
        "atl_date": "2020-03-13T02:27:44.591Z",
        "roi": {
            "times": 73.21884474610569,
            "currency": "usd",
            "percentage": 7321.884474610569
        },
        "last_updated": "2023-09-18T15:21:35.143Z"
    },
    {
        "id": "hedera-hashgraph",
        "symbol": "hbar",
        "name": "Hedera",
        "image": "https://assets.coingecko.com/coins/images/3688/large/hbar.png?1637045634",
        "current_price": 0.051297,
        "market_cap": 1706894336,
        "market_cap_rank": 31,
        "fully_diluted_valuation": 2566091414,
        "total_volume": 19389465,
        "high_24h": 0.051485,
        "low_24h": 0.04909423,
        "price_change_24h": 0.0009085,
        "price_change_percentage_24h": 1.80299,
        "market_cap_change_24h": 31807246,
        "market_cap_change_percentage_24h": 1.89884,
        "circulating_supply": 33258642432.8273,
        "total_supply": 50000000000,
        "max_supply": 50000000000,
        "ath": 0.569229,
        "ath_change_percentage": -90.9876,
        "ath_date": "2021-09-15T10:40:28.318Z",
        "atl": 0.00986111,
        "atl_change_percentage": 420.23727,
        "atl_date": "2020-01-02T17:30:24.852Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:44.095Z"
    },
    {
        "id": "filecoin",
        "symbol": "fil",
        "name": "Filecoin",
        "image": "https://assets.coingecko.com/coins/images/12817/large/filecoin.png?1602753933",
        "current_price": 3.39,
        "market_cap": 1526041487,
        "market_cap_rank": 32,
        "fully_diluted_valuation": 6659729865,
        "total_volume": 92367728,
        "high_24h": 3.4,
        "low_24h": 3.27,
        "price_change_24h": 0.01765554,
        "price_change_percentage_24h": 0.52338,
        "market_cap_change_24h": 13053390,
        "market_cap_change_percentage_24h": 0.86276,
        "circulating_supply": 449442904,
        "total_supply": 1961393812,
        "max_supply": 1961393812,
        "ath": 236.84,
        "ath_change_percentage": -98.56825,
        "ath_date": "2021-04-01T13:29:41.564Z",
        "atl": 2.64,
        "atl_change_percentage": 28.39855,
        "atl_date": "2022-12-16T22:45:28.552Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:43.674Z"
    },
    {
        "id": "lido-dao",
        "symbol": "ldo",
        "name": "Lido DAO",
        "image": "https://assets.coingecko.com/coins/images/13573/large/Lido_DAO.png?1609873644",
        "current_price": 1.57,
        "market_cap": 1394953898,
        "market_cap_rank": 33,
        "fully_diluted_valuation": 1567453923,
        "total_volume": 31325376,
        "high_24h": 1.58,
        "low_24h": 1.49,
        "price_change_24h": 0.0438007,
        "price_change_percentage_24h": 2.87306,
        "market_cap_change_24h": 37787703,
        "market_cap_change_percentage_24h": 2.78431,
        "circulating_supply": 889948901.825874,
        "total_supply": 1000000000,
        "max_supply": 1000000000,
        "ath": 7.3,
        "ath_change_percentage": -78.57183,
        "ath_date": "2021-08-20T08:35:20.158Z",
        "atl": 0.40615,
        "atl_change_percentage": 285.29429,
        "atl_date": "2022-06-18T20:55:12.035Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:42.925Z"
    },
    {
        "id": "crypto-com-chain",
        "symbol": "cro",
        "name": "Cronos",
        "image": "https://assets.coingecko.com/coins/images/7310/large/cro_token_logo.png?1669699773",
        "current_price": 0.051784,
        "market_cap": 1361321402,
        "market_cap_rank": 34,
        "fully_diluted_valuation": 1554372486,
        "total_volume": 8946834,
        "high_24h": 0.051965,
        "low_24h": 0.05096,
        "price_change_24h": 0.00021107,
        "price_change_percentage_24h": 0.40927,
        "market_cap_change_24h": 11042911,
        "market_cap_change_percentage_24h": 0.81782,
        "circulating_supply": 26274038193.9557,
        "total_supply": 30000000000,
        "max_supply": null,
        "ath": 0.965407,
        "ath_change_percentage": -94.67724,
        "ath_date": "2021-11-24T15:53:54.855Z",
        "atl": 0.0121196,
        "atl_change_percentage": 323.99377,
        "atl_date": "2019-02-08T00:00:00.000Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:42.296Z"
    },
    {
        "id": "quant-network",
        "symbol": "qnt",
        "name": "Quant",
        "image": "https://assets.coingecko.com/coins/images/3370/large/5ZOu7brX_400x400.jpg?1612437252",
        "current_price": 92.39,
        "market_cap": 1344242233,
        "market_cap_rank": 35,
        "fully_diluted_valuation": 1350556402,
        "total_volume": 15589777,
        "high_24h": 92.8,
        "low_24h": 90.07,
        "price_change_24h": 1.091,
        "price_change_percentage_24h": 1.19497,
        "market_cap_change_24h": 15053816,
        "market_cap_change_percentage_24h": 1.13256,
        "circulating_supply": 14544176.164091088,
        "total_supply": 14612493,
        "max_supply": 14612493,
        "ath": 427.42,
        "ath_change_percentage": -78.38691,
        "ath_date": "2021-09-11T09:15:00.668Z",
        "atl": 0.215773,
        "atl_change_percentage": 42713.07078,
        "atl_date": "2018-08-23T00:00:00.000Z",
        "roi": {
            "times": 22.945849329698312,
            "currency": "eth",
            "percentage": 2294.5849329698312
        },
        "last_updated": "2023-09-18T15:21:44.374Z"
    },
    {
        "id": "internet-computer",
        "symbol": "icp",
        "name": "Internet Computer",
        "image": "https://assets.coingecko.com/coins/images/14495/large/Internet_Computer_logo.png?1620703073",
        "current_price": 3.01,
        "market_cap": 1339708077,
        "market_cap_rank": 36,
        "fully_diluted_valuation": 1524153955,
        "total_volume": 21405516,
        "high_24h": 3.03,
        "low_24h": 2.9,
        "price_change_24h": 0.02258249,
        "price_change_percentage_24h": 0.75533,
        "market_cap_change_24h": 11379040,
        "market_cap_change_percentage_24h": 0.85664,
        "circulating_supply": 444849109.268264,
        "total_supply": 506094231.176241,
        "max_supply": null,
        "ath": 700.65,
        "ath_change_percentage": -99.56965,
        "ath_date": "2021-05-10T16:05:53.653Z",
        "atl": 2.88,
        "atl_change_percentage": 4.64703,
        "atl_date": "2023-09-13T08:00:01.314Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:40.867Z"
    },
    {
        "id": "mantle",
        "symbol": "mnt",
        "name": "Mantle",
        "image": "https://assets.coingecko.com/coins/images/30980/large/token-logo.png?1689320029",
        "current_price": 0.406816,
        "market_cap": 1314191649,
        "market_cap_rank": 37,
        "fully_diluted_valuation": 2527028043,
        "total_volume": 28074753,
        "high_24h": 0.407639,
        "low_24h": 0.401778,
        "price_change_24h": 0.002367,
        "price_change_percentage_24h": 0.58524,
        "market_cap_change_24h": 6737560,
        "market_cap_change_percentage_24h": 0.51532,
        "circulating_supply": 3234382070.76314,
        "total_supply": 6219316794.99,
        "max_supply": 6219316794.99,
        "ath": 0.600075,
        "ath_change_percentage": -32.22214,
        "ath_date": "2023-07-20T22:39:30.228Z",
        "atl": 0.401216,
        "atl_change_percentage": 1.37127,
        "atl_date": "2023-09-11T21:11:51.804Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:47.557Z"
    },
    {
        "id": "vechain",
        "symbol": "vet",
        "name": "VeChain",
        "image": "https://assets.coingecko.com/coins/images/1167/large/VET_Token_Icon.png?1680067517",
        "current_price": 0.01765863,
        "market_cap": 1283763820,
        "market_cap_rank": 38,
        "fully_diluted_valuation": 1530898474,
        "total_volume": 39116393,
        "high_24h": 0.01771091,
        "low_24h": 0.01700647,
        "price_change_24h": 0.00009127,
        "price_change_percentage_24h": 0.51956,
        "market_cap_change_24h": 6771505,
        "market_cap_change_percentage_24h": 0.53027,
        "circulating_supply": 72714516834,
        "total_supply": 85985041177,
        "max_supply": 86712634466,
        "ath": 0.280991,
        "ath_change_percentage": -93.7147,
        "ath_date": "2021-04-19T01:08:21.675Z",
        "atl": 0.00191713,
        "atl_change_percentage": 821.22644,
        "atl_date": "2020-03-13T02:29:59.652Z",
        "roi": {
            "times": 2.725396027816487,
            "currency": "eth",
            "percentage": 272.5396027816487
        },
        "last_updated": "2023-09-18T15:21:37.358Z"
    },
    {
        "id": "aptos",
        "symbol": "apt",
        "name": "Aptos",
        "image": "https://assets.coingecko.com/coins/images/26455/large/aptos_round.png?1666839629",
        "current_price": 5.32,
        "market_cap": 1255473759,
        "market_cap_rank": 39,
        "fully_diluted_valuation": 5622644963,
        "total_volume": 67980744,
        "high_24h": 5.36,
        "low_24h": 5.17,
        "price_change_24h": 0.0264708,
        "price_change_percentage_24h": 0.5,
        "market_cap_change_24h": 7336191,
        "market_cap_change_percentage_24h": 0.58777,
        "circulating_supply": 235739736.089726,
        "total_supply": 1055761485.09315,
        "max_supply": null,
        "ath": 19.92,
        "ath_change_percentage": -73.26161,
        "ath_date": "2023-01-26T14:25:17.390Z",
        "atl": 3.08,
        "atl_change_percentage": 72.94634,
        "atl_date": "2022-12-29T21:35:14.796Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:45.963Z"
    },
    {
        "id": "maker",
        "symbol": "mkr",
        "name": "Maker",
        "image": "https://assets.coingecko.com/coins/images/1364/large/Mark_Maker.png?1585191826",
        "current_price": 1261.81,
        "market_cap": 1137488821,
        "market_cap_rank": 40,
        "fully_diluted_valuation": 1269076559,
        "total_volume": 72190812,
        "high_24h": 1279.83,
        "low_24h": 1238.07,
        "price_change_24h": -15.020439031368142,
        "price_change_percentage_24h": -1.17638,
        "market_cap_change_24h": -14954098.171231508,
        "market_cap_change_percentage_24h": -1.2976,
        "circulating_supply": 901310.9472893132,
        "total_supply": 977631.036950888,
        "max_supply": 1005577,
        "ath": 6292.31,
        "ath_change_percentage": -79.94823,
        "ath_date": "2021-05-03T21:54:29.333Z",
        "atl": 168.36,
        "atl_change_percentage": 649.42882,
        "atl_date": "2020-03-16T20:52:36.527Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:43.600Z"
    },
    {
        "id": "optimism",
        "symbol": "op",
        "name": "Optimism",
        "image": "https://assets.coingecko.com/coins/images/25244/large/Optimism.png?1660904599",
        "current_price": 1.41,
        "market_cap": 1124543506,
        "market_cap_rank": 41,
        "fully_diluted_valuation": 6048557715,
        "total_volume": 68409117,
        "high_24h": 1.42,
        "low_24h": 1.36,
        "price_change_24h": 0.02275812,
        "price_change_percentage_24h": 1.64058,
        "market_cap_change_24h": 16513663,
        "market_cap_change_percentage_24h": 1.49036,
        "circulating_supply": 798517235,
        "total_supply": 4294967296,
        "max_supply": 4294967296,
        "ath": 3.22,
        "ath_change_percentage": -56.31013,
        "ath_date": "2023-02-24T20:20:00.509Z",
        "atl": 0.402159,
        "atl_change_percentage": 250.16153,
        "atl_date": "2022-06-18T20:54:52.178Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:43.999Z"
    },
    {
        "id": "arbitrum",
        "symbol": "arb",
        "name": "Arbitrum",
        "image": "https://assets.coingecko.com/coins/images/16547/large/photo_2023-03-29_21.47.00.jpeg?1680097630",
        "current_price": 0.833995,
        "market_cap": 1061496278,
        "market_cap_rank": 42,
        "fully_diluted_valuation": 8325461006,
        "total_volume": 135985445,
        "high_24h": 0.835542,
        "low_24h": 0.784801,
        "price_change_24h": 0.02254906,
        "price_change_percentage_24h": 2.77887,
        "market_cap_change_24h": 25070647,
        "market_cap_change_percentage_24h": 2.41895,
        "circulating_supply": 1275000000,
        "total_supply": 10000000000,
        "max_supply": 10000000000,
        "ath": 8.67,
        "ath_change_percentage": -90.408,
        "ath_date": "2023-03-23T13:10:03.106Z",
        "atl": 0.744925,
        "atl_change_percentage": 11.68084,
        "atl_date": "2023-09-11T19:40:49.196Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:38.688Z"
    },
    {
        "id": "near",
        "symbol": "near",
        "name": "NEAR Protocol",
        "image": "https://assets.coingecko.com/coins/images/10365/large/near.jpg?1683515160",
        "current_price": 1.12,
        "market_cap": 1055489313,
        "market_cap_rank": 43,
        "fully_diluted_valuation": 1120867833,
        "total_volume": 51575795,
        "high_24h": 1.13,
        "low_24h": 1.081,
        "price_change_24h": 0.01000468,
        "price_change_percentage_24h": 0.89998,
        "market_cap_change_24h": 8586294,
        "market_cap_change_percentage_24h": 0.82016,
        "circulating_supply": 941671517.686093,
        "total_supply": 1000000000,
        "max_supply": null,
        "ath": 20.44,
        "ath_change_percentage": -94.51938,
        "ath_date": "2022-01-16T22:09:45.873Z",
        "atl": 0.526762,
        "atl_change_percentage": 112.64539,
        "atl_date": "2020-11-04T16:09:15.137Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:45.310Z"
    },
    {
        "id": "kaspa",
        "symbol": "kas",
        "name": "Kaspa",
        "image": "https://assets.coingecko.com/coins/images/25751/large/kaspa-icon-exchanges.png?1653891958",
        "current_price": 0.04780282,
        "market_cap": 993215452,
        "market_cap_rank": 44,
        "fully_diluted_valuation": 1377277161,
        "total_volume": 14779922,
        "high_24h": 0.04966959,
        "low_24h": 0.04476167,
        "price_change_24h": 0.00276616,
        "price_change_percentage_24h": 6.14203,
        "market_cap_change_24h": 57453260,
        "market_cap_change_percentage_24h": 6.13973,
        "circulating_supply": 20699742625.1371,
        "total_supply": 20698863093.8361,
        "max_supply": 28704026601,
        "ath": 0.051714,
        "ath_change_percentage": -6.92661,
        "ath_date": "2023-08-06T12:10:40.416Z",
        "atl": 0.00017105,
        "atl_change_percentage": 28039.20777,
        "atl_date": "2022-05-26T14:42:59.316Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:47.479Z"
    },
    {
        "id": "rocket-pool-eth",
        "symbol": "reth",
        "name": "Rocket Pool ETH",
        "image": "https://assets.coingecko.com/coins/images/20764/large/reth.png?1637652366",
        "current_price": 1803.27,
        "market_cap": 949278488,
        "market_cap_rank": 45,
        "fully_diluted_valuation": 949278488,
        "total_volume": 3650871,
        "high_24h": 1811.83,
        "low_24h": 1749.58,
        "price_change_24h": 34.43,
        "price_change_percentage_24h": 1.94631,
        "market_cap_change_24h": 17410977,
        "market_cap_change_percentage_24h": 1.8684,
        "circulating_supply": 526507.050738605,
        "total_supply": 526507.050738605,
        "max_supply": null,
        "ath": 4814.31,
        "ath_change_percentage": -62.58211,
        "ath_date": "2021-12-01T08:03:50.749Z",
        "atl": 887.26,
        "atl_change_percentage": 103.03027,
        "atl_date": "2022-06-18T20:55:45.957Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:46.633Z"
    },
    {
        "id": "aave",
        "symbol": "aave",
        "name": "Aave",
        "image": "https://assets.coingecko.com/coins/images/12645/large/AAVE.png?1601374110",
        "current_price": 61.71,
        "market_cap": 896708049,
        "market_cap_rank": 46,
        "fully_diluted_valuation": 986833055,
        "total_volume": 100489726,
        "high_24h": 62.39,
        "low_24h": 58.45,
        "price_change_24h": 1.1,
        "price_change_percentage_24h": 1.82195,
        "market_cap_change_24h": 13398049,
        "market_cap_change_percentage_24h": 1.5168,
        "circulating_supply": 14538759.839553142,
        "total_supply": 16000000,
        "max_supply": 16000000,
        "ath": 661.69,
        "ath_change_percentage": -90.679,
        "ath_date": "2021-05-18T21:19:59.514Z",
        "atl": 26.02,
        "atl_change_percentage": 137.00483,
        "atl_date": "2020-11-05T09:20:11.928Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:44.692Z"
    },
    {
        "id": "the-graph",
        "symbol": "grt",
        "name": "The Graph",
        "image": "https://assets.coingecko.com/coins/images/13397/large/Graph_Token.png?1608145566",
        "current_price": 0.087798,
        "market_cap": 810394494,
        "market_cap_rank": 47,
        "fully_diluted_valuation": 878644346,
        "total_volume": 23216117,
        "high_24h": 0.087943,
        "low_24h": 0.083272,
        "price_change_24h": 0.00205277,
        "price_change_percentage_24h": 2.39404,
        "market_cap_change_24h": 21747446,
        "market_cap_change_percentage_24h": 2.75756,
        "circulating_supply": 9223236885.60183,
        "total_supply": 10000000000,
        "max_supply": null,
        "ath": 2.84,
        "ath_change_percentage": -96.91104,
        "ath_date": "2021-02-12T07:28:45.775Z",
        "atl": 0.052051,
        "atl_change_percentage": 68.62863,
        "atl_date": "2022-11-22T10:05:03.503Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:39.977Z"
    },
    {
        "id": "algorand",
        "symbol": "algo",
        "name": "Algorand",
        "image": "https://assets.coingecko.com/coins/images/4380/large/download.png?1547039725",
        "current_price": 0.098292,
        "market_cap": 769088866,
        "market_cap_rank": 48,
        "fully_diluted_valuation": 982329864,
        "total_volume": 19321069,
        "high_24h": 0.098391,
        "low_24h": 0.093888,
        "price_change_24h": 0.00244345,
        "price_change_percentage_24h": 2.54929,
        "market_cap_change_24h": 16800365,
        "market_cap_change_percentage_24h": 2.23323,
        "circulating_supply": 7829232263.34326,
        "total_supply": 7829232274.99626,
        "max_supply": 10000000000,
        "ath": 3.56,
        "ath_change_percentage": -97.23985,
        "ath_date": "2019-06-20T14:51:19.480Z",
        "atl": 0.087513,
        "atl_change_percentage": 12.31771,
        "atl_date": "2023-09-11T19:42:08.247Z",
        "roi": {
            "times": -0.959045155146524,
            "currency": "usd",
            "percentage": -95.9045155146524
        },
        "last_updated": "2023-09-18T15:21:38.040Z"
    },
    {
        "id": "whitebit",
        "symbol": "wbt",
        "name": "WhiteBIT Coin",
        "image": "https://assets.coingecko.com/coins/images/27045/large/wbt_token.png?1667923752",
        "current_price": 5.32,
        "market_cap": 766257558,
        "market_cap_rank": 49,
        "fully_diluted_valuation": 2126742833,
        "total_volume": 7934341,
        "high_24h": 5.33,
        "low_24h": 5.26,
        "price_change_24h": 0.04497459,
        "price_change_percentage_24h": 0.85247,
        "market_cap_change_24h": 5772924,
        "market_cap_change_percentage_24h": 0.75911,
        "circulating_supply": 144118517.10815412,
        "total_supply": 367539300,
        "max_supply": 400000000,
        "ath": 14.64,
        "ath_change_percentage": -63.66074,
        "ath_date": "2022-10-28T12:32:18.119Z",
        "atl": 3.06,
        "atl_change_percentage": 73.81576,
        "atl_date": "2023-02-13T19:01:21.899Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:02.347Z"
    },
    {
        "id": "usdd",
        "symbol": "usdd",
        "name": "USDD",
        "image": "https://assets.coingecko.com/coins/images/25380/large/UUSD.jpg?1651823371",
        "current_price": 0.999876,
        "market_cap": 725295061,
        "market_cap_rank": 50,
        "fully_diluted_valuation": null,
        "total_volume": 24343636,
        "high_24h": 1.001,
        "low_24h": 0.996354,
        "price_change_24h": 0.00177565,
        "price_change_percentage_24h": 0.1779,
        "market_cap_change_24h": 762176,
        "market_cap_change_percentage_24h": 0.1052,
        "circulating_supply": 725629010.798669,
        "total_supply": null,
        "max_supply": null,
        "ath": 1.044,
        "ath_change_percentage": -4.27697,
        "ath_date": "2022-11-09T09:56:06.131Z",
        "atl": 0.928067,
        "atl_change_percentage": 7.67152,
        "atl_date": "2022-06-19T16:15:11.558Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:43.148Z"
    },
    {
        "id": "xdce-crowd-sale",
        "symbol": "xdc",
        "name": "XDC Network",
        "image": "https://assets.coingecko.com/coins/images/2912/large/xdc-icon.png?1633700890",
        "current_price": 0.052241,
        "market_cap": 722074915,
        "market_cap_rank": 51,
        "fully_diluted_valuation": 1972053482,
        "total_volume": 3339453,
        "high_24h": 0.05364,
        "low_24h": 0.052025,
        "price_change_24h": -0.000655074863165323,
        "price_change_percentage_24h": -1.23843,
        "market_cap_change_24h": -12498974.582698464,
        "market_cap_change_percentage_24h": -1.70153,
        "circulating_supply": 13864073367.75,
        "total_supply": 37864068655.8,
        "max_supply": null,
        "ath": 0.192754,
        "ath_change_percentage": -72.9327,
        "ath_date": "2021-08-21T04:39:48.324Z",
        "atl": 0.00039532,
        "atl_change_percentage": 13097.81287,
        "atl_date": "2019-07-22T00:00:00.000Z",
        "roi": {
            "times": 3.1873387623337632,
            "currency": "eth",
            "percentage": 318.73387623337635
        },
        "last_updated": "2023-09-18T15:21:39.091Z"
    },
    {
        "id": "havven",
        "symbol": "snx",
        "name": "Synthetix Network",
        "image": "https://assets.coingecko.com/coins/images/3406/large/SNX.png?1598631139",
        "current_price": 2.19,
        "market_cap": 706902256,
        "market_cap_rank": 52,
        "fully_diluted_valuation": 708484442,
        "total_volume": 22927464,
        "high_24h": 2.21,
        "low_24h": 2.11,
        "price_change_24h": 0.03536149,
        "price_change_percentage_24h": 1.64441,
        "market_cap_change_24h": 10291180,
        "market_cap_change_percentage_24h": 1.47732,
        "circulating_supply": 323433678.13952357,
        "total_supply": 324157586.088774,
        "max_supply": 324157586.088774,
        "ath": 28.53,
        "ath_change_percentage": -92.34043,
        "ath_date": "2021-02-14T01:12:38.505Z",
        "atl": 0.0347864,
        "atl_change_percentage": 6182.48736,
        "atl_date": "2019-01-06T00:00:00.000Z",
        "roi": {
            "times": 3.371541635143434,
            "currency": "usd",
            "percentage": 337.1541635143434
        },
        "last_updated": "2023-09-18T15:21:39.338Z"
    },
    {
        "id": "blockstack",
        "symbol": "stx",
        "name": "Stacks",
        "image": "https://assets.coingecko.com/coins/images/2069/large/Stacks_logo_full.png?1604112510",
        "current_price": 0.495216,
        "market_cap": 690451694,
        "market_cap_rank": 53,
        "fully_diluted_valuation": 892369529,
        "total_volume": 51143345,
        "high_24h": 0.502239,
        "low_24h": 0.447931,
        "price_change_24h": 0.03585138,
        "price_change_percentage_24h": 7.80456,
        "market_cap_change_24h": 44559435,
        "market_cap_change_percentage_24h": 6.8989,
        "circulating_supply": 1406638324.75219,
        "total_supply": 1818000000,
        "max_supply": 1818000000,
        "ath": 3.39,
        "ath_change_percentage": -85.39456,
        "ath_date": "2021-12-01T01:32:34.725Z",
        "atl": 0.04559639,
        "atl_change_percentage": 985.76828,
        "atl_date": "2020-03-13T02:29:26.415Z",
        "roi": {
            "times": 3.126798140320079,
            "currency": "usd",
            "percentage": 312.6798140320079
        },
        "last_updated": "2023-09-18T15:21:39.484Z"
    },
    {
        "id": "elrond-erd-2",
        "symbol": "egld",
        "name": "MultiversX",
        "image": "https://assets.coingecko.com/coins/images/12335/large/egld-token-logo.png?1673490885",
        "current_price": 26.21,
        "market_cap": 680525885,
        "market_cap_rank": 54,
        "fully_diluted_valuation": 823164017,
        "total_volume": 17442791,
        "high_24h": 26.33,
        "low_24h": 25.09,
        "price_change_24h": 0.410284,
        "price_change_percentage_24h": 1.59037,
        "market_cap_change_24h": 8382950,
        "market_cap_change_percentage_24h": 1.2472,
        "circulating_supply": 25972164,
        "total_supply": 25977316,
        "max_supply": 31415926,
        "ath": 545.64,
        "ath_change_percentage": -95.20114,
        "ath_date": "2021-11-23T10:33:26.737Z",
        "atl": 6.51,
        "atl_change_percentage": 302.42567,
        "atl_date": "2020-10-07T01:44:53.554Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:46.466Z"
    },
    {
        "id": "frax",
        "symbol": "frax",
        "name": "Frax",
        "image": "https://assets.coingecko.com/coins/images/13422/large/FRAX_icon.png?1679886922",
        "current_price": 0.996994,
        "market_cap": 669698518,
        "market_cap_rank": 55,
        "fully_diluted_valuation": 669698518,
        "total_volume": 4219540,
        "high_24h": 0.999181,
        "low_24h": 0.988957,
        "price_change_24h": -0.000197624786931083,
        "price_change_percentage_24h": -0.01982,
        "market_cap_change_24h": -201063.55074989796,
        "market_cap_change_percentage_24h": -0.03001,
        "circulating_supply": 671723780.559441,
        "total_supply": 671723780.559441,
        "max_supply": null,
        "ath": 1.14,
        "ath_change_percentage": -12.65344,
        "ath_date": "2021-02-07T12:55:35.766Z",
        "atl": 0.874536,
        "atl_change_percentage": 13.90549,
        "atl_date": "2023-03-11T07:50:39.316Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:42.882Z"
    },
    {
        "id": "eos",
        "symbol": "eos",
        "name": "EOS",
        "image": "https://assets.coingecko.com/coins/images/738/large/eos-eos-logo.png?1547034481",
        "current_price": 0.577745,
        "market_cap": 647806612,
        "market_cap_rank": 56,
        "fully_diluted_valuation": null,
        "total_volume": 65410918,
        "high_24h": 0.581592,
        "low_24h": 0.551638,
        "price_change_24h": 0.00991332,
        "price_change_percentage_24h": 1.74582,
        "market_cap_change_24h": 11379012,
        "market_cap_change_percentage_24h": 1.78795,
        "circulating_supply": 1120847990.1313,
        "total_supply": null,
        "max_supply": null,
        "ath": 22.71,
        "ath_change_percentage": -97.45659,
        "ath_date": "2018-04-29T07:50:33.540Z",
        "atl": 0.5024,
        "atl_change_percentage": 14.97635,
        "atl_date": "2017-10-23T00:00:00.000Z",
        "roi": {
            "times": -0.41641960423617785,
            "currency": "usd",
            "percentage": -41.64196042361779
        },
        "last_updated": "2023-09-18T15:21:42.926Z"
    },
    {
        "id": "tezos",
        "symbol": "xtz",
        "name": "Tezos",
        "image": "https://assets.coingecko.com/coins/images/976/large/Tezos-logo.png?1547034862",
        "current_price": 0.676767,
        "market_cap": 638800231,
        "market_cap_rank": 57,
        "fully_diluted_valuation": null,
        "total_volume": 16719926,
        "high_24h": 0.681534,
        "low_24h": 0.652333,
        "price_change_24h": 0.00920319,
        "price_change_percentage_24h": 1.37862,
        "market_cap_change_24h": 8217462,
        "market_cap_change_percentage_24h": 1.30315,
        "circulating_supply": 944661026.267597,
        "total_supply": null,
        "max_supply": null,
        "ath": 9.12,
        "ath_change_percentage": -92.57519,
        "ath_date": "2021-10-04T00:41:18.025Z",
        "atl": 0.350476,
        "atl_change_percentage": 93.12326,
        "atl_date": "2018-12-07T00:00:00.000Z",
        "roi": {
            "times": 0.43992969083585215,
            "currency": "usd",
            "percentage": 43.992969083585216
        },
        "last_updated": "2023-09-18T15:21:38.501Z"
    },
    {
        "id": "bitget-token",
        "symbol": "bgb",
        "name": "Bitget Token",
        "image": "https://assets.coingecko.com/coins/images/11610/large/icon_colour.png?1690515455",
        "current_price": 0.453524,
        "market_cap": 634407634,
        "market_cap_rank": 58,
        "fully_diluted_valuation": 906295973,
        "total_volume": 20315812,
        "high_24h": 0.455386,
        "low_24h": 0.448707,
        "price_change_24h": 0.00378274,
        "price_change_percentage_24h": 0.84109,
        "market_cap_change_24h": 4391354,
        "market_cap_change_percentage_24h": 0.69702,
        "circulating_supply": 1400001000,
        "total_supply": 2000000000,
        "max_supply": 2000000000,
        "ath": 0.515471,
        "ath_change_percentage": -12.00883,
        "ath_date": "2023-02-16T08:52:49.445Z",
        "atl": 0.0142795,
        "atl_change_percentage": 3076.36529,
        "atl_date": "2020-06-25T04:17:05.895Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:11.437Z"
    },
    {
        "id": "the-sandbox",
        "symbol": "sand",
        "name": "The Sandbox",
        "image": "https://assets.coingecko.com/coins/images/12129/large/sandbox_logo.jpg?1597397942",
        "current_price": 0.304648,
        "market_cap": 629453463,
        "market_cap_rank": 59,
        "fully_diluted_valuation": 914490383,
        "total_volume": 36576112,
        "high_24h": 0.305711,
        "low_24h": 0.292075,
        "price_change_24h": 0.00259231,
        "price_change_percentage_24h": 0.85822,
        "market_cap_change_24h": 4637450,
        "market_cap_change_percentage_24h": 0.74221,
        "circulating_supply": 2064931926.2233226,
        "total_supply": 3000000000,
        "max_supply": 3000000000,
        "ath": 8.4,
        "ath_change_percentage": -96.36885,
        "ath_date": "2021-11-25T06:04:40.957Z",
        "atl": 0.02897764,
        "atl_change_percentage": 952.19161,
        "atl_date": "2020-11-04T15:59:14.441Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:39.363Z"
    },
    {
        "id": "immutable-x",
        "symbol": "imx",
        "name": "ImmutableX",
        "image": "https://assets.coingecko.com/coins/images/17233/large/immutableX-symbol-BLK-RGB.png?1665110648",
        "current_price": 0.535135,
        "market_cap": 624622674,
        "market_cap_rank": 60,
        "fully_diluted_valuation": 1070018162,
        "total_volume": 547706958,
        "high_24h": 0.539193,
        "low_24h": 0.512105,
        "price_change_24h": 0.00170672,
        "price_change_percentage_24h": 0.31995,
        "market_cap_change_24h": 2052447,
        "market_cap_change_percentage_24h": 0.32967,
        "circulating_supply": 1167499199.0700243,
        "total_supply": 2000000000,
        "max_supply": 2000000000,
        "ath": 9.52,
        "ath_change_percentage": -94.3727,
        "ath_date": "2021-11-26T01:03:01.536Z",
        "atl": 0.378055,
        "atl_change_percentage": 41.70301,
        "atl_date": "2022-12-31T07:36:37.649Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:48.408Z"
    },
    {
        "id": "injective-protocol",
        "symbol": "inj",
        "name": "Injective",
        "image": "https://assets.coingecko.com/coins/images/12882/large/Secondary_Symbol.png?1628233237",
        "current_price": 7.39,
        "market_cap": 617996084,
        "market_cap_rank": 61,
        "fully_diluted_valuation": 737856826,
        "total_volume": 39652488,
        "high_24h": 7.45,
        "low_24h": 6.92,
        "price_change_24h": 0.23563,
        "price_change_percentage_24h": 3.295,
        "market_cap_change_24h": 17606912,
        "market_cap_change_percentage_24h": 2.93258,
        "circulating_supply": 83755555.66,
        "total_supply": 100000000,
        "max_supply": 100000000,
        "ath": 24.89,
        "ath_change_percentage": -70.32521,
        "ath_date": "2021-04-30T00:33:02.969Z",
        "atl": 0.657401,
        "atl_change_percentage": 1023.51794,
        "atl_date": "2020-11-03T16:19:30.576Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:43.828Z"
    },
    {
        "id": "bitcoin-cash-sv",
        "symbol": "bsv",
        "name": "Bitcoin SV",
        "image": "https://assets.coingecko.com/coins/images/6799/large/BSV.png?1558947902",
        "current_price": 31.98,
        "market_cap": 616319858,
        "market_cap_rank": 62,
        "fully_diluted_valuation": 671787892,
        "total_volume": 12999930,
        "high_24h": 32.97,
        "low_24h": 30.55,
        "price_change_24h": 0.734915,
        "price_change_percentage_24h": 2.35244,
        "market_cap_change_24h": 14037465,
        "market_cap_change_percentage_24h": 2.33071,
        "circulating_supply": 19266076.644239,
        "total_supply": 21000000,
        "max_supply": 21000000,
        "ath": 489.75,
        "ath_change_percentage": -93.44578,
        "ath_date": "2021-04-16T17:09:04.630Z",
        "atl": 21.43,
        "atl_change_percentage": 49.7532,
        "atl_date": "2023-06-10T04:32:12.266Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:45.819Z"
    },
    {
        "id": "theta-token",
        "symbol": "theta",
        "name": "Theta Network",
        "image": "https://assets.coingecko.com/coins/images/2538/large/theta-token-logo.png?1548387191",
        "current_price": 0.611541,
        "market_cap": 611804434,
        "market_cap_rank": 63,
        "fully_diluted_valuation": 611804434,
        "total_volume": 11039134,
        "high_24h": 0.618674,
        "low_24h": 0.591235,
        "price_change_24h": 0.00426346,
        "price_change_percentage_24h": 0.70206,
        "market_cap_change_24h": 4060486,
        "market_cap_change_percentage_24h": 0.66812,
        "circulating_supply": 1000000000,
        "total_supply": 1000000000,
        "max_supply": 1000000000,
        "ath": 15.72,
        "ath_change_percentage": -96.10778,
        "ath_date": "2021-04-16T13:15:11.190Z",
        "atl": 0.04039979,
        "atl_change_percentage": 1414.47725,
        "atl_date": "2020-03-13T02:24:16.483Z",
        "roi": {
            "times": 3.076941692589568,
            "currency": "usd",
            "percentage": 307.6941692589568
        },
        "last_updated": "2023-09-18T15:21:39.867Z"
    },
    {
        "id": "render-token",
        "symbol": "rndr",
        "name": "Render",
        "image": "https://assets.coingecko.com/coins/images/11636/large/rndr.png?1638840934",
        "current_price": 1.62,
        "market_cap": 602345034,
        "market_cap_rank": 64,
        "fully_diluted_valuation": 860049913,
        "total_volume": 26419192,
        "high_24h": 1.63,
        "low_24h": 1.54,
        "price_change_24h": 0.02681652,
        "price_change_percentage_24h": 1.68698,
        "market_cap_change_24h": 10286700,
        "market_cap_change_percentage_24h": 1.73745,
        "circulating_supply": 371908453.108796,
        "total_supply": 531024271.388796,
        "max_supply": 531024271.388796,
        "ath": 8.78,
        "ath_change_percentage": -81.53742,
        "ath_date": "2021-11-21T10:03:19.097Z",
        "atl": 0.03665669,
        "atl_change_percentage": 4323.66765,
        "atl_date": "2020-06-16T13:22:25.900Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:45.287Z"
    },
    {
        "id": "axie-infinity",
        "symbol": "axs",
        "name": "Axie Infinity",
        "image": "https://assets.coingecko.com/coins/images/13029/large/axie_infinity_logo.png?1604471082",
        "current_price": 4.59,
        "market_cap": 600230571,
        "market_cap_rank": 65,
        "fully_diluted_valuation": 1235757310,
        "total_volume": 28395818,
        "high_24h": 4.6,
        "low_24h": 4.44,
        "price_change_24h": -0.002542491911212253,
        "price_change_percentage_24h": -0.05541,
        "market_cap_change_24h": -1290006.965686798,
        "market_cap_change_percentage_24h": -0.21446,
        "circulating_supply": 131144078.93382938,
        "total_supply": 270000000,
        "max_supply": 270000000,
        "ath": 164.9,
        "ath_change_percentage": -97.22593,
        "ath_date": "2021-11-06T19:29:29.482Z",
        "atl": 0.123718,
        "atl_change_percentage": 3597.41381,
        "atl_date": "2020-11-06T08:05:43.662Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:42.846Z"
    },
    {
        "id": "thorchain",
        "symbol": "rune",
        "name": "THORChain",
        "image": "https://assets.coingecko.com/coins/images/6595/large/Rune200x200.png?1671179394",
        "current_price": 1.96,
        "market_cap": 587726748,
        "market_cap_rank": 66,
        "fully_diluted_valuation": 977262474,
        "total_volume": 104556829,
        "high_24h": 1.98,
        "low_24h": 1.82,
        "price_change_24h": 0.058703,
        "price_change_percentage_24h": 3.09269,
        "market_cap_change_24h": 16044174,
        "market_cap_change_percentage_24h": 2.80648,
        "circulating_supply": 300700561,
        "total_supply": 500000000,
        "max_supply": 500000000,
        "ath": 20.87,
        "ath_change_percentage": -90.63598,
        "ath_date": "2021-05-19T00:30:09.436Z",
        "atl": 0.00851264,
        "atl_change_percentage": 22854.62404,
        "atl_date": "2019-09-28T00:00:00.000Z",
        "roi": {
            "times": 50.49567587774,
            "currency": "usd",
            "percentage": 5049.567587774
        },
        "last_updated": "2023-09-18T15:21:40.407Z"
    },
    {
        "id": "radix",
        "symbol": "xrd",
        "name": "Radix",
        "image": "https://assets.coingecko.com/coins/images/4374/large/Radix.png?1629701658",
        "current_price": 0.05639,
        "market_cap": 577898677,
        "market_cap_rank": 67,
        "fully_diluted_valuation": 1352532330,
        "total_volume": 2350548,
        "high_24h": 0.056513,
        "low_24h": 0.054187,
        "price_change_24h": 0.00137734,
        "price_change_percentage_24h": 2.50367,
        "market_cap_change_24h": 13795129,
        "market_cap_change_percentage_24h": 2.4455,
        "circulating_supply": 10254518832.1907,
        "total_supply": 12654500869.5099,
        "max_supply": 24000000000,
        "ath": 0.651264,
        "ath_change_percentage": -91.34144,
        "ath_date": "2021-11-14T16:09:27.130Z",
        "atl": 0.03145312,
        "atl_change_percentage": 79.28281,
        "atl_date": "2022-11-29T23:20:09.754Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:40.995Z"
    },
    {
        "id": "fantom",
        "symbol": "ftm",
        "name": "Fantom",
        "image": "https://assets.coingecko.com/coins/images/4001/large/Fantom_round.png?1669652346",
        "current_price": 0.194413,
        "market_cap": 544819554,
        "market_cap_rank": 68,
        "fully_diluted_valuation": 616985516,
        "total_volume": 42186063,
        "high_24h": 0.196214,
        "low_24h": 0.188279,
        "price_change_24h": 0.0023317,
        "price_change_percentage_24h": 1.21391,
        "market_cap_change_24h": 6370528,
        "market_cap_change_percentage_24h": 1.18313,
        "circulating_supply": 2803634835.52659,
        "total_supply": 3175000000,
        "max_supply": 3175000000,
        "ath": 3.46,
        "ath_change_percentage": -94.37877,
        "ath_date": "2021-10-28T05:19:39.845Z",
        "atl": 0.00190227,
        "atl_change_percentage": 10120.1311,
        "atl_date": "2020-03-13T02:25:38.280Z",
        "roi": {
            "times": 5.480421335500886,
            "currency": "usd",
            "percentage": 548.0421335500887
        },
        "last_updated": "2023-09-18T15:21:44.325Z"
    },
    {
        "id": "decentraland",
        "symbol": "mana",
        "name": "Decentraland",
        "image": "https://assets.coingecko.com/coins/images/878/large/decentraland-mana.png?1550108745",
        "current_price": 0.295623,
        "market_cap": 544767262,
        "market_cap_rank": 69,
        "fully_diluted_valuation": 648261261,
        "total_volume": 32957270,
        "high_24h": 0.296463,
        "low_24h": 0.28597,
        "price_change_24h": 0.00108934,
        "price_change_percentage_24h": 0.36985,
        "market_cap_change_24h": 1901432,
        "market_cap_change_percentage_24h": 0.35026,
        "circulating_supply": 1843041331.60632,
        "total_supply": 2193179327.32015,
        "max_supply": 2193179327.32015,
        "ath": 5.85,
        "ath_change_percentage": -94.95159,
        "ath_date": "2021-11-25T10:04:18.534Z",
        "atl": 0.00923681,
        "atl_change_percentage": 3097.78994,
        "atl_date": "2017-10-31T00:00:00.000Z",
        "roi": {
            "times": 13.781167557207375,
            "currency": "usd",
            "percentage": 1378.1167557207375
        },
        "last_updated": "2023-09-18T15:21:44.109Z"
    },
    {
        "id": "gatechain-token",
        "symbol": "gt",
        "name": "Gate",
        "image": "https://assets.coingecko.com/coins/images/8183/large/gate.png?1687143308",
        "current_price": 3.86,
        "market_cap": 529985223,
        "market_cap_rank": 70,
        "fully_diluted_valuation": 1157446134,
        "total_volume": 491873,
        "high_24h": 3.87,
        "low_24h": 3.82,
        "price_change_24h": -0.002230755269593488,
        "price_change_percentage_24h": -0.05772,
        "market_cap_change_24h": -913512.0943138599,
        "market_cap_change_percentage_24h": -0.17207,
        "circulating_supply": 137367573.56752193,
        "total_supply": 300000000,
        "max_supply": null,
        "ath": 12.94,
        "ath_change_percentage": -70.19117,
        "ath_date": "2021-05-12T11:39:16.531Z",
        "atl": 0.25754,
        "atl_change_percentage": 1397.94743,
        "atl_date": "2020-03-13T02:18:02.481Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:43.166Z"
    },
    {
        "id": "neo",
        "symbol": "neo",
        "name": "NEO",
        "image": "https://assets.coingecko.com/coins/images/480/large/NEO_512_512.png?1594357361",
        "current_price": 7.48,
        "market_cap": 527072904,
        "market_cap_rank": 71,
        "fully_diluted_valuation": 747303139,
        "total_volume": 18939850,
        "high_24h": 7.51,
        "low_24h": 7.07,
        "price_change_24h": 0.283455,
        "price_change_percentage_24h": 3.93895,
        "market_cap_change_24h": 19563729,
        "market_cap_change_percentage_24h": 3.85485,
        "circulating_supply": 70530000,
        "total_supply": 100000000,
        "max_supply": null,
        "ath": 198.38,
        "ath_change_percentage": -96.23355,
        "ath_date": "2018-01-15T00:00:00.000Z",
        "atl": 0.078349,
        "atl_change_percentage": 9436.67814,
        "atl_date": "2016-10-21T00:00:00.000Z",
        "roi": {
            "times": 206.76860317342803,
            "currency": "usd",
            "percentage": 20676.860317342802
        },
        "last_updated": "2023-09-18T15:21:40.773Z"
    },
    {
        "id": "ecash",
        "symbol": "xec",
        "name": "eCash",
        "image": "https://assets.coingecko.com/coins/images/16646/large/Logo_final-22.png?1628239446",
        "current_price": 0.00002701,
        "market_cap": 517549214,
        "market_cap_rank": 72,
        "fully_diluted_valuation": 557304292,
        "total_volume": 98725969,
        "high_24h": 0.00002855,
        "low_24h": 0.00002244,
        "price_change_24h": 0.00000375,
        "price_change_percentage_24h": 16.14565,
        "market_cap_change_24h": 64031125,
        "market_cap_change_percentage_24h": 14.11876,
        "circulating_supply": 19501973423093,
        "total_supply": 21000000000000,
        "max_supply": 21000000000000,
        "ath": 0.00038001,
        "ath_change_percentage": -93.00352,
        "ath_date": "2021-09-04T17:09:31.137Z",
        "atl": 0.00001847,
        "atl_change_percentage": 43.95067,
        "atl_date": "2021-07-20T20:49:46.212Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:40.577Z"
    },
    {
        "id": "kava",
        "symbol": "kava",
        "name": "Kava",
        "image": "https://assets.coingecko.com/coins/images/9761/large/kava.png?1663638871",
        "current_price": 0.635358,
        "market_cap": 494053862,
        "market_cap_rank": 73,
        "fully_diluted_valuation": 494028128,
        "total_volume": 18022118,
        "high_24h": 0.645005,
        "low_24h": 0.611186,
        "price_change_24h": -0.008622913833431611,
        "price_change_percentage_24h": -1.339,
        "market_cap_change_24h": -3381857.591920018,
        "market_cap_change_percentage_24h": -0.67986,
        "circulating_supply": 775587570,
        "total_supply": 775547171,
        "max_supply": null,
        "ath": 9.12,
        "ath_change_percentage": -93.02194,
        "ath_date": "2021-08-30T11:10:02.948Z",
        "atl": 0.287137,
        "atl_change_percentage": 121.6418,
        "atl_date": "2020-03-13T02:24:16.835Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:40.380Z"
    },
    {
        "id": "paxos-standard",
        "symbol": "usdp",
        "name": "Pax Dollar",
        "image": "https://assets.coingecko.com/coins/images/6013/large/Pax_Dollar.png?1629877204",
        "current_price": 0.998487,
        "market_cap": 491794661,
        "market_cap_rank": 74,
        "fully_diluted_valuation": 491794661,
        "total_volume": 3764471,
        "high_24h": 1.001,
        "low_24h": 0.996188,
        "price_change_24h": -0.001275479773006239,
        "price_change_percentage_24h": -0.12758,
        "market_cap_change_24h": -667234.6100344062,
        "market_cap_change_percentage_24h": -0.13549,
        "circulating_supply": 492639163.180683,
        "total_supply": 492639163.180683,
        "max_supply": null,
        "ath": 1.13,
        "ath_change_percentage": -11.51829,
        "ath_date": "2018-10-15T07:09:12.459Z",
        "atl": 0.863529,
        "atl_change_percentage": 15.54746,
        "atl_date": "2021-05-19T13:14:42.046Z",
        "roi": {
            "times": -0.0015130891686522,
            "currency": "usd",
            "percentage": -0.15130891686522
        },
        "last_updated": "2023-09-18T15:21:43.866Z"
    },
    {
        "id": "compound-ether",
        "symbol": "ceth",
        "name": "cETH",
        "image": "https://assets.coingecko.com/coins/images/10643/large/ceth.png?1687143191",
        "current_price": 33.29,
        "market_cap": 489980084,
        "market_cap_rank": 75,
        "fully_diluted_valuation": 489980084,
        "total_volume": 447.94,
        "high_24h": 33.48,
        "low_24h": 32.4,
        "price_change_24h": 0.540931,
        "price_change_percentage_24h": 1.65178,
        "market_cap_change_24h": 7820810,
        "market_cap_change_percentage_24h": 1.62204,
        "circulating_supply": 14718820.3917181,
        "total_supply": 14718820.3917181,
        "max_supply": null,
        "ath": 97.75,
        "ath_change_percentage": -65.92028,
        "ath_date": "2021-11-21T12:39:57.508Z",
        "atl": 1.89,
        "atl_change_percentage": 1666.06709,
        "atl_date": "2020-03-13T02:22:33.711Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:30.047Z"
    },
    {
        "id": "tether-gold",
        "symbol": "xaut",
        "name": "Tether Gold",
        "image": "https://assets.coingecko.com/coins/images/10481/large/Tether_Gold.png?1668148656",
        "current_price": 1927.02,
        "market_cap": 475017316,
        "market_cap_rank": 76,
        "fully_diluted_valuation": 475017316,
        "total_volume": 3315315,
        "high_24h": 1930.1,
        "low_24h": 1922.42,
        "price_change_24h": 2.57,
        "price_change_percentage_24h": 0.13363,
        "market_cap_change_24h": 678978,
        "market_cap_change_percentage_24h": 0.14314,
        "circulating_supply": 246524.33,
        "total_supply": 246524.33,
        "max_supply": null,
        "ath": 2169.74,
        "ath_change_percentage": -11.20375,
        "ath_date": "2023-03-15T20:36:21.941Z",
        "atl": 1447.84,
        "atl_change_percentage": 33.07041,
        "atl_date": "2020-03-19T13:45:41.821Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:44.921Z"
    },
    {
        "id": "pax-gold",
        "symbol": "paxg",
        "name": "PAX Gold",
        "image": "https://assets.coingecko.com/coins/images/9519/large/paxgold.png?1687143101",
        "current_price": 1912.35,
        "market_cap": 474523783,
        "market_cap_rank": 77,
        "fully_diluted_valuation": 474523783,
        "total_volume": 7344444,
        "high_24h": 1918.25,
        "low_24h": 1902.9,
        "price_change_24h": 7.72,
        "price_change_percentage_24h": 0.40533,
        "market_cap_change_24h": 1415221,
        "market_cap_change_percentage_24h": 0.29913,
        "circulating_supply": 248316.55,
        "total_supply": 248316.55,
        "max_supply": null,
        "ath": 2241.37,
        "ath_change_percentage": -14.68203,
        "ath_date": "2021-05-17T19:02:29.657Z",
        "atl": 1399.64,
        "atl_change_percentage": 36.62719,
        "atl_date": "2019-11-18T03:09:35.959Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:37.204Z"
    },
    {
        "id": "flow",
        "symbol": "flow",
        "name": "Flow",
        "image": "https://assets.coingecko.com/coins/images/13446/large/5f6294c0c7a8cda55cb1c936_Flow_Wordmark.png?1631696776",
        "current_price": 0.450088,
        "market_cap": 466699781,
        "market_cap_rank": 78,
        "fully_diluted_valuation": 655806587,
        "total_volume": 22960496,
        "high_24h": 0.457834,
        "low_24h": 0.432335,
        "price_change_24h": 0.00179713,
        "price_change_percentage_24h": 0.40089,
        "market_cap_change_24h": 1889299,
        "market_cap_change_percentage_24h": 0.40647,
        "circulating_supply": 1036200000,
        "total_supply": 1456068361.18633,
        "max_supply": 1456068361.18633,
        "ath": 42.4,
        "ath_change_percentage": -98.93698,
        "ath_date": "2021-04-05T13:49:10.098Z",
        "atl": 0.391969,
        "atl_change_percentage": 14.9814,
        "atl_date": "2023-09-11T19:41:06.528Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:38.920Z"
    },
    {
        "id": "rocket-pool",
        "symbol": "rpl",
        "name": "Rocket Pool",
        "image": "https://assets.coingecko.com/coins/images/2090/large/rocket_pool_%28RPL%29.png?1637662441",
        "current_price": 22.99,
        "market_cap": 452547977,
        "market_cap_rank": 79,
        "fully_diluted_valuation": 452547977,
        "total_volume": 2831467,
        "high_24h": 23,
        "low_24h": 22.3,
        "price_change_24h": 0.333107,
        "price_change_percentage_24h": 1.47005,
        "market_cap_change_24h": 6279546,
        "market_cap_change_percentage_24h": 1.40712,
        "circulating_supply": 19694369.8469077,
        "total_supply": 19694369.8469077,
        "max_supply": null,
        "ath": 61.9,
        "ath_change_percentage": -62.85357,
        "ath_date": "2023-04-16T19:20:19.534Z",
        "atl": 0.00884718,
        "atl_change_percentage": 259789.27839,
        "atl_date": "2018-08-28T00:00:00.000Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:37.771Z"
    },
    {
        "id": "rollbit-coin",
        "symbol": "rlb",
        "name": "Rollbit Coin",
        "image": "https://assets.coingecko.com/coins/images/24552/large/unziL6wO_400x400.jpg?1648134494",
        "current_price": 0.130921,
        "market_cap": 435838135,
        "market_cap_rank": 80,
        "fully_diluted_valuation": 660971383,
        "total_volume": 9915390,
        "high_24h": 0.146313,
        "low_24h": 0.12425,
        "price_change_24h": -0.011167834208344303,
        "price_change_percentage_24h": -7.85976,
        "market_cap_change_24h": -32402134.495403826,
        "market_cap_change_percentage_24h": -6.91998,
        "circulating_supply": 3296951621.59,
        "total_supply": 3296951622,
        "max_supply": 5000000000,
        "ath": 0.213089,
        "ath_change_percentage": -37.93102,
        "ath_date": "2023-08-12T14:31:00.633Z",
        "atl": 0.00093506,
        "atl_change_percentage": 14044.81487,
        "atl_date": "2022-07-02T02:46:34.730Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:44.537Z"
    },
    {
        "id": "frax-ether",
        "symbol": "frxeth",
        "name": "Frax Ether",
        "image": "https://assets.coingecko.com/coins/images/28284/large/frxETH_icon.png?1679886981",
        "current_price": 1657.65,
        "market_cap": 430715741,
        "market_cap_rank": 81,
        "fully_diluted_valuation": 430715741,
        "total_volume": 1421092,
        "high_24h": 1665.32,
        "low_24h": 1609.29,
        "price_change_24h": 29.78,
        "price_change_percentage_24h": 1.82939,
        "market_cap_change_24h": 7314800,
        "market_cap_change_percentage_24h": 1.72763,
        "circulating_supply": 260108.012756798,
        "total_supply": 260108.012756798,
        "max_supply": null,
        "ath": 2134.61,
        "ath_change_percentage": -22.43151,
        "ath_date": "2023-04-16T19:24:52.171Z",
        "atl": 1137.25,
        "atl_change_percentage": 45.59591,
        "atl_date": "2022-11-23T02:25:33.267Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:40.581Z"
    },
    {
        "id": "apecoin",
        "symbol": "ape",
        "name": "ApeCoin",
        "image": "https://assets.coingecko.com/coins/images/24383/large/apecoin.jpg?1647476455",
        "current_price": 1.15,
        "market_cap": 422680751,
        "market_cap_rank": 82,
        "fully_diluted_valuation": 1146738791,
        "total_volume": 92686243,
        "high_24h": 1.17,
        "low_24h": 1.092,
        "price_change_24h": 0.03237815,
        "price_change_percentage_24h": 2.90414,
        "market_cap_change_24h": 11655690,
        "market_cap_change_percentage_24h": 2.83576,
        "circulating_supply": 368593750,
        "total_supply": 1000000000,
        "max_supply": 1000000000,
        "ath": 26.7,
        "ath_change_percentage": -95.70528,
        "ath_date": "2022-04-28T21:44:21.164Z",
        "atl": 1.076,
        "atl_change_percentage": 6.52073,
        "atl_date": "2023-09-17T01:10:34.686Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:38.083Z"
    },
    {
        "id": "kucoin-shares",
        "symbol": "kcs",
        "name": "KuCoin",
        "image": "https://assets.coingecko.com/coins/images/1047/large/sa9z79.png?1610678720",
        "current_price": 4.34,
        "market_cap": 419876119,
        "market_cap_rank": 83,
        "fully_diluted_valuation": 626053106,
        "total_volume": 427627,
        "high_24h": 4.35,
        "low_24h": 4.25,
        "price_change_24h": 0.063099,
        "price_change_percentage_24h": 1.47473,
        "market_cap_change_24h": 6205234,
        "market_cap_change_percentage_24h": 1.50004,
        "circulating_supply": 96732986.425851,
        "total_supply": 144232986.425767,
        "max_supply": null,
        "ath": 28.83,
        "ath_change_percentage": -84.94231,
        "ath_date": "2021-12-01T15:09:35.541Z",
        "atl": 0.342863,
        "atl_change_percentage": 1166.13705,
        "atl_date": "2019-02-07T00:00:00.000Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:30.664Z"
    },
    {
        "id": "chiliz",
        "symbol": "chz",
        "name": "Chiliz",
        "image": "https://assets.coingecko.com/coins/images/8834/large/CHZ_Token_updated.png?1675848257",
        "current_price": 0.059609,
        "market_cap": 415811396,
        "market_cap_rank": 84,
        "fully_diluted_valuation": 529857834,
        "total_volume": 34769024,
        "high_24h": 0.059812,
        "low_24h": 0.056304,
        "price_change_24h": 0.00152139,
        "price_change_percentage_24h": 2.61913,
        "market_cap_change_24h": 10881547,
        "market_cap_change_percentage_24h": 2.68727,
        "circulating_supply": 6975647158.46,
        "total_supply": 8888888888,
        "max_supply": 8888888888,
        "ath": 0.878633,
        "ath_change_percentage": -93.21294,
        "ath_date": "2021-03-13T08:04:21.200Z",
        "atl": 0.00410887,
        "atl_change_percentage": 1351.33044,
        "atl_date": "2019-09-28T00:00:00.000Z",
        "roi": {
            "times": 1.7095103949772623,
            "currency": "usd",
            "percentage": 170.9510394977262
        },
        "last_updated": "2023-09-18T15:21:45.500Z"
    },
    {
        "id": "iota",
        "symbol": "miota",
        "name": "IOTA",
        "image": "https://assets.coingecko.com/coins/images/692/large/IOTA_Swirl.png?1604238557",
        "current_price": 0.147434,
        "market_cap": 412039401,
        "market_cap_rank": 85,
        "fully_diluted_valuation": 412039401,
        "total_volume": 14531623,
        "high_24h": 0.15175,
        "low_24h": 0.147256,
        "price_change_24h": -0.002966731930399147,
        "price_change_percentage_24h": -1.97255,
        "market_cap_change_24h": -6104877.07388711,
        "market_cap_change_percentage_24h": -1.45999,
        "circulating_supply": 2779530283.277761,
        "total_supply": 2779530283,
        "max_supply": null,
        "ath": 5.25,
        "ath_change_percentage": -97.19351,
        "ath_date": "2017-12-19T00:00:00.000Z",
        "atl": 0.081637,
        "atl_change_percentage": 80.44006,
        "atl_date": "2020-03-13T02:22:41.168Z",
        "roi": {
            "times": 3.029245961806697,
            "currency": "btc",
            "percentage": 302.9245961806697
        },
        "last_updated": "2023-09-18T15:21:47.526Z"
    },
    {
        "id": "tokenize-xchange",
        "symbol": "tkx",
        "name": "Tokenize Xchange",
        "image": "https://assets.coingecko.com/coins/images/4984/large/TKX_-_Logo_-_RGB-15.png?1672912391",
        "current_price": 5.12,
        "market_cap": 409827144,
        "market_cap_rank": 86,
        "fully_diluted_valuation": 512309545,
        "total_volume": 7234246,
        "high_24h": 5.14,
        "low_24h": 4.99,
        "price_change_24h": -0.0119046831637446,
        "price_change_percentage_24h": -0.23206,
        "market_cap_change_24h": -418042.439381063,
        "market_cap_change_percentage_24h": -0.1019,
        "circulating_supply": 79995999.94518414,
        "total_supply": 100000000,
        "max_supply": 100000000,
        "ath": 22.3,
        "ath_change_percentage": -77.04503,
        "ath_date": "2022-10-31T10:23:59.455Z",
        "atl": 0.111255,
        "atl_change_percentage": 4500.34045,
        "atl_date": "2019-04-28T00:00:00.000Z",
        "roi": {
            "times": 16.61822440888866,
            "currency": "usd",
            "percentage": 1661.8224408888661
        },
        "last_updated": "2023-09-18T15:20:54.818Z"
    },
    {
        "id": "frax-share",
        "symbol": "fxs",
        "name": "Frax Share",
        "image": "https://assets.coingecko.com/coins/images/13423/large/Frax_Shares_icon.png?1679886947",
        "current_price": 5.4,
        "market_cap": 397202578,
        "market_cap_rank": 87,
        "fully_diluted_valuation": 537335843,
        "total_volume": 26093232,
        "high_24h": 5.4,
        "low_24h": 5.17,
        "price_change_24h": 0.158071,
        "price_change_percentage_24h": 3.01614,
        "market_cap_change_24h": 10962111,
        "market_cap_change_percentage_24h": 2.83816,
        "circulating_supply": 73685289.3513665,
        "total_supply": 99681495.5911336,
        "max_supply": 99681495.5911336,
        "ath": 42.8,
        "ath_change_percentage": -87.4004,
        "ath_date": "2022-01-12T15:22:27.465Z",
        "atl": 1.5,
        "atl_change_percentage": 258.75096,
        "atl_date": "2021-06-25T16:50:51.447Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:41.588Z"
    },
    {
        "id": "casper-network",
        "symbol": "cspr",
        "name": "Casper Network",
        "image": "https://assets.coingecko.com/coins/images/15279/large/casper.PNG?1620341020",
        "current_price": 0.03506888,
        "market_cap": 396951149,
        "market_cap_rank": 88,
        "fully_diluted_valuation": 421228686,
        "total_volume": 2834149,
        "high_24h": 0.03543898,
        "low_24h": 0.03374002,
        "price_change_24h": 0.00100943,
        "price_change_percentage_24h": 2.96373,
        "market_cap_change_24h": 10992127,
        "market_cap_change_percentage_24h": 2.848,
        "circulating_supply": 11326770593,
        "total_supply": 12019516020,
        "max_supply": null,
        "ath": 1.33,
        "ath_change_percentage": -97.35922,
        "ath_date": "2021-05-12T00:00:00.000Z",
        "atl": 0.02241297,
        "atl_change_percentage": 56.16898,
        "atl_date": "2022-06-18T20:14:44.694Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:24.655Z"
    },
    {
        "id": "first-digital-usd",
        "symbol": "fdusd",
        "name": "First Digital USD",
        "image": "https://assets.coingecko.com/coins/images/31079/large/firstfigital.jpeg?1690347713",
        "current_price": 1.002,
        "market_cap": 394091502,
        "market_cap_rank": 89,
        "fully_diluted_valuation": 394091502,
        "total_volume": 491628300,
        "high_24h": 1.007,
        "low_24h": 0.996869,
        "price_change_24h": 0.00280225,
        "price_change_percentage_24h": 0.28055,
        "market_cap_change_24h": -161328.0930607319,
        "market_cap_change_percentage_24h": -0.04092,
        "circulating_supply": 393868096.72,
        "total_supply": 393868096.72,
        "max_supply": null,
        "ath": 1.026,
        "ath_change_percentage": -2.45414,
        "ath_date": "2023-08-17T23:15:16.752Z",
        "atl": 0.942129,
        "atl_change_percentage": 6.18413,
        "atl_date": "2023-08-17T21:55:41.478Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:08.414Z"
    },
    {
        "id": "huobi-token",
        "symbol": "ht",
        "name": "HTX",
        "image": "https://assets.coingecko.com/coins/images/2822/large/huobi-token-logo.png?1547036992",
        "current_price": 2.45,
        "market_cap": 389523317,
        "market_cap_rank": 90,
        "fully_diluted_valuation": 491284049,
        "total_volume": 9811289,
        "high_24h": 2.45,
        "low_24h": 2.41,
        "price_change_24h": 0.02398796,
        "price_change_percentage_24h": 0.99079,
        "market_cap_change_24h": 2712388,
        "market_cap_change_percentage_24h": 0.70122,
        "circulating_supply": 159406077,
        "total_supply": 201050000,
        "max_supply": 201050000,
        "ath": 39.66,
        "ath_change_percentage": -93.83589,
        "ath_date": "2021-05-12T14:42:21.586Z",
        "atl": 0.3138,
        "atl_change_percentage": 679.07398,
        "atl_date": "2023-03-10T05:05:00+08:00",
        "roi": {
            "times": 1.469791694853698,
            "currency": "usd",
            "percentage": 146.9791694853698
        },
        "last_updated": "2023-09-18T15:21:44.475Z"
    },
    {
        "id": "curve-dao-token",
        "symbol": "crv",
        "name": "Curve DAO",
        "image": "https://assets.coingecko.com/coins/images/12124/large/Curve.png?1597369484",
        "current_price": 0.442823,
        "market_cap": 389057968,
        "market_cap_rank": 91,
        "fully_diluted_valuation": 1463165301,
        "total_volume": 37010052,
        "high_24h": 0.447466,
        "low_24h": 0.423678,
        "price_change_24h": 0.00237111,
        "price_change_percentage_24h": 0.53833,
        "market_cap_change_24h": 1952054,
        "market_cap_change_percentage_24h": 0.50427,
        "circulating_supply": 878280981,
        "total_supply": 2011968151.24383,
        "max_supply": 3303030299,
        "ath": 15.37,
        "ath_change_percentage": -97.11335,
        "ath_date": "2020-08-14T00:00:00.000Z",
        "atl": 0.331577,
        "atl_change_percentage": 33.82677,
        "atl_date": "2020-11-05T13:09:50.181Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:41.618Z"
    },
    {
        "id": "gala",
        "symbol": "gala",
        "name": "GALA",
        "image": "https://assets.coingecko.com/coins/images/12493/large/GALA-COINGECKO.png?1600233435",
        "current_price": 0.01461235,
        "market_cap": 382455459,
        "market_cap_rank": 92,
        "fully_diluted_valuation": 729696639,
        "total_volume": 603431573,
        "high_24h": 0.01471839,
        "low_24h": 0.01388487,
        "price_change_24h": 0.00007755,
        "price_change_percentage_24h": 0.53353,
        "market_cap_change_24h": 2069002,
        "market_cap_change_percentage_24h": 0.54392,
        "circulating_supply": 26206469809.8961,
        "total_supply": 26206340218.2897,
        "max_supply": 50000000000,
        "ath": 0.824837,
        "ath_change_percentage": -98.23008,
        "ath_date": "2021-11-26T01:03:48.731Z",
        "atl": 0.00013475,
        "atl_change_percentage": 10734.12551,
        "atl_date": "2020-12-28T08:46:48.367Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:39.536Z"
    },
    {
        "id": "klay-token",
        "symbol": "klay",
        "name": "Klaytn",
        "image": "https://assets.coingecko.com/coins/images/9672/large/klaytn.png?1660288824",
        "current_price": 0.118758,
        "market_cap": 377901025,
        "market_cap_rank": 93,
        "fully_diluted_valuation": null,
        "total_volume": 9336408,
        "high_24h": 0.118868,
        "low_24h": 0.11496,
        "price_change_24h": 0.0013153,
        "price_change_percentage_24h": 1.11995,
        "market_cap_change_24h": 2082846,
        "market_cap_change_percentage_24h": 0.55422,
        "circulating_supply": 3185679942.0609,
        "total_supply": null,
        "max_supply": null,
        "ath": 4.34,
        "ath_change_percentage": -97.26507,
        "ath_date": "2021-03-30T03:44:28.828Z",
        "atl": 0.06044,
        "atl_change_percentage": 96.3385,
        "atl_date": "2020-04-29T08:19:34.574Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:36.074Z"
    },
    {
        "id": "bittorrent",
        "symbol": "btt",
        "name": "BitTorrent",
        "image": "https://assets.coingecko.com/coins/images/22457/large/btt_logo.png?1643857231",
        "current_price": 3.94933e-7,
        "market_cap": 375542213,
        "market_cap_rank": 94,
        "fully_diluted_valuation": 390769713,
        "total_volume": 22326506,
        "high_24h": 3.95225e-7,
        "low_24h": 3.90017e-7,
        "price_change_24h": 2.258e-9,
        "price_change_percentage_24h": 0.57498,
        "market_cap_change_24h": 1953170,
        "market_cap_change_percentage_24h": 0.52281,
        "circulating_supply": 951421714286000,
        "total_supply": 990000000000000,
        "max_supply": 990000000000000,
        "ath": 0.00000343,
        "ath_change_percentage": -88.50257,
        "ath_date": "2022-01-21T04:00:31.909Z",
        "atl": 3.83301e-7,
        "atl_change_percentage": 2.92598,
        "atl_date": "2023-09-12T02:16:50.436Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:37.201Z"
    },
    {
        "id": "mina-protocol",
        "symbol": "mina",
        "name": "Mina Protocol",
        "image": "https://assets.coingecko.com/coins/images/15628/large/JM4_vQ34_400x400.png?1621394004",
        "current_price": 0.383327,
        "market_cap": 371729147,
        "market_cap_rank": 95,
        "fully_diluted_valuation": 412026334,
        "total_volume": 5897279,
        "high_24h": 0.386216,
        "low_24h": 0.367594,
        "price_change_24h": 0.00523477,
        "price_change_percentage_24h": 1.38452,
        "market_cap_change_24h": 5973496,
        "market_cap_change_percentage_24h": 1.63319,
        "circulating_supply": 969944003.840039,
        "total_supply": 1075090492.84004,
        "max_supply": null,
        "ath": 9.09,
        "ath_change_percentage": -95.78789,
        "ath_date": "2021-06-01T01:42:37.064Z",
        "atl": 0.35734,
        "atl_change_percentage": 7.15144,
        "atl_date": "2023-09-11T19:42:08.669Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:40.910Z"
    },
    {
        "id": "sui",
        "symbol": "sui",
        "name": "Sui",
        "image": "https://assets.coingecko.com/coins/images/26375/large/sui_asset.jpeg?1683114182",
        "current_price": 0.448058,
        "market_cap": 354639713,
        "market_cap_rank": 96,
        "fully_diluted_valuation": 4479032048,
        "total_volume": 45069634,
        "high_24h": 0.449202,
        "low_24h": 0.427196,
        "price_change_24h": 0.00303903,
        "price_change_percentage_24h": 0.6829,
        "market_cap_change_24h": 2566290,
        "market_cap_change_percentage_24h": 0.72891,
        "circulating_supply": 791777575.076923,
        "total_supply": 10000000000,
        "max_supply": 10000000000,
        "ath": 2.16,
        "ath_change_percentage": -79.23212,
        "ath_date": "2023-05-03T12:00:26.430Z",
        "atl": 0.419073,
        "atl_change_percentage": 7.1672,
        "atl_date": "2023-09-13T06:11:40.304Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:40.356Z"
    },
    {
        "id": "dydx",
        "symbol": "dydx",
        "name": "dYdX",
        "image": "https://assets.coingecko.com/coins/images/17500/large/hjnIm9bV.jpg?1628009360",
        "current_price": 1.96,
        "market_cap": 344231917,
        "market_cap_rank": 97,
        "fully_diluted_valuation": 1962200617,
        "total_volume": 50684067,
        "high_24h": 1.98,
        "low_24h": 1.9,
        "price_change_24h": 0.00773389,
        "price_change_percentage_24h": 0.39527,
        "market_cap_change_24h": 656246,
        "market_cap_change_percentage_24h": 0.191,
        "circulating_supply": 175431560.84889272,
        "total_supply": 1000000000,
        "max_supply": 1000000000,
        "ath": 27.86,
        "ath_change_percentage": -92.96583,
        "ath_date": "2021-09-30T01:23:43.570Z",
        "atl": 1.011,
        "atl_change_percentage": 93.91896,
        "atl_date": "2022-06-18T20:55:50.603Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:39.722Z"
    },
    {
        "id": "coinbase-wrapped-staked-eth",
        "symbol": "cbeth",
        "name": "Coinbase Wrapped Staked ETH",
        "image": "https://assets.coingecko.com/coins/images/27008/large/cbeth.png?1661390066",
        "current_price": 1740.94,
        "market_cap": 342493841,
        "market_cap_rank": 98,
        "fully_diluted_valuation": 2226435209,
        "total_volume": 1696876,
        "high_24h": 1748.1,
        "low_24h": 1689.33,
        "price_change_24h": 33.65,
        "price_change_percentage_24h": 1.97097,
        "market_cap_change_24h": 7812231,
        "market_cap_change_percentage_24h": 2.33423,
        "circulating_supply": 197010.625630133,
        "total_supply": 1280698.63019673,
        "max_supply": null,
        "ath": 2191.04,
        "ath_change_percentage": -20.66322,
        "ath_date": "2023-04-16T19:25:37.525Z",
        "atl": 1036.96,
        "atl_change_percentage": 67.63483,
        "atl_date": "2022-11-09T23:45:43.665Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:40.746Z"
    },
    {
        "id": "trust-wallet-token",
        "symbol": "twt",
        "name": "Trust Wallet",
        "image": "https://assets.coingecko.com/coins/images/11085/large/Trust.png?1588062702",
        "current_price": 0.813939,
        "market_cap": 339193386,
        "market_cap_rank": 99,
        "fully_diluted_valuation": 814096886,
        "total_volume": 7049382,
        "high_24h": 0.814632,
        "low_24h": 0.788358,
        "price_change_24h": 0.01423868,
        "price_change_percentage_24h": 1.7805,
        "market_cap_change_24h": 5810226,
        "market_cap_change_percentage_24h": 1.74281,
        "circulating_supply": 416649900,
        "total_supply": 1000000000,
        "max_supply": null,
        "ath": 2.72,
        "ath_change_percentage": -70.08717,
        "ath_date": "2022-12-11T23:25:46.205Z",
        "atl": 0.00277641,
        "atl_change_percentage": 29214.8538,
        "atl_date": "2020-06-09T09:15:06.983Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:43.176Z"
    },
    {
        "id": "terra-luna",
        "symbol": "lunc",
        "name": "Terra Luna Classic",
        "image": "https://assets.coingecko.com/coins/images/8284/large/01_LunaClassic_color.png?1653547790",
        "current_price": 0.00005825,
        "market_cap": 339050749,
        "market_cap_rank": 100,
        "fully_diluted_valuation": 398110597,
        "total_volume": 11581453,
        "high_24h": 0.00005847,
        "low_24h": 0.00005603,
        "price_change_24h": 0.00000142,
        "price_change_percentage_24h": 2.50228,
        "market_cap_change_24h": 7580314,
        "market_cap_change_percentage_24h": 2.28687,
        "circulating_supply": 5821441223936.38,
        "total_supply": 6835488338965.25,
        "max_supply": null,
        "ath": 119.18,
        "ath_change_percentage": -99.99995,
        "ath_date": "2022-04-05T12:24:58.854Z",
        "atl": 9.99967e-7,
        "atl_change_percentage": 5716.40057,
        "atl_date": "2022-05-13T02:34:40.340Z",
        "roi": null,
        "last_updated": "2023-09-18T15:21:45.723Z"
    }
]
export default {
    arr,
}